// /**
//  * TdProductSearch Web Component
//  * Handles product search for third-party testing certificates using local JSON data
//  *
//  * @class TdProductSearch
//  * @extends HTMLElement
//  */

// /**
//  * Simple service class for accessing pre-rendered product data
//  */
// class ProductDataService {
//   constructor() {
//     this.productData = {};
//     this.isDataLoaded = false;
//     this.waitForProductData();
//   }

//   /**
//    * Wait for product data to be available
//    */
//   waitForProductData() {
//     if (window.tdProductData) {
//       this.productData = window.tdProductData;
//       this.isDataLoaded = true;
//       //console.log(`Loaded product data for ${Object.keys(this.productData).length} products`);
//     } else {
//       console.error('Product data not found. Make sure sb-product-data-map.js.liquid is loaded.');
//     }
//   }

//   /**
//    * Get product data by handle (synchronous)
//    * @param {string} handle - Product handle
//    * @returns {Object|null} Product data or null if not found
//    */
//   getProductByHandle(handle) {
//     if (!this.isDataLoaded) {
//       console.warn('Product data not yet loaded');
//       return null;
//     }

//     return this.productData[handle] || null;
//   }

//   /**
//    * Get multiple products by handles (synchronous)
//    * @param {Array<string>} handles - Array of product handles
//    * @returns {Array<Object>} Array of product data
//    */
//   getProductsBatch(handles) {
//     return handles.map((handle) => this.getProductByHandle(handle)).filter(Boolean);
//   }

//   /**
//    * Check if product data is loaded
//    * @returns {boolean} True if data is loaded
//    */
//   isLoaded() {
//     return this.isDataLoaded;
//   }
// }

// // Check if custom element is already defined
// if (!customElements.get('sb-product-search')) {
//   class TdProductSearch extends HTMLElement {
//     constructor() {
//       super();
//       this.searchInput = null;
//       this.searchResults = null;
//       this.searchButton = null;
//       this.searchTimeout = null;
//       this.recentProductContainer = null;
//       this.recentProductContent = null;
//       this.searchHistoryList = null;
//       this.recentSection = null;
//       this.searchHistorySection = null;
//       this.certificateData = [];
//       this.isDataLoaded = false;
//       this.productService = new ProductDataService();
//       this.modalId = null;
//     }

//     connectedCallback() {
//       this.initializeElements();
//       this.waitForCertificateData();
//       this.setupEventListeners();
//       this.initializeDataDependentSections();
//       this.modalId = this.getAttribute('data-modal-id');
//     }

//     /**
//      * Initialize sections that depend on data being loaded
//      */
//     initializeDataDependentSections() {
//       // Only load and show sections if both product and certificate data are available
//       if (this.productService.isLoaded() && this.isDataLoaded) {
//         this.loadRecentProduct();
//         this.loadSearchHistory();
//         this.showDataDependentSections();
//       } else {
//         // Wait a bit and try again
//         setTimeout(() => this.initializeDataDependentSections(), 100);
//       }
//     }

//     /**
//      * Show the sections that depend on data being loaded
//      */
//     showDataDependentSections() {
//       if (this.recentSection) {
//         this.recentSection.classList.add('sb-third-party-testing__recent-section--visible');
//       }
//       if (this.searchHistorySection) {
//         this.searchHistorySection.classList.add('sb-third-party-testing__search-history--visible');
//       }
//     }

//     /**
//      * Initialize DOM element references
//      */
//     initializeElements() {
//       this.searchInput = this.querySelector('[data-search-input]');
//       this.searchResults = this.querySelector('[data-search-results]');
//       this.searchButton = this.querySelector('[data-search-button]');
//       this.recentTitle = document.querySelector('[data-recent-title]');
//       this.recentProductContainer = document.querySelector('[data-recent-product]');
//       this.recentProductContent = document.querySelector('[data-recent-content]');
//       this.searchHistoryList = document.querySelector('[data-search-history-list]');
//       this.recentSection = document.querySelector('[data-recent-section]');
//       this.searchHistorySection = document.querySelector('[data-search-history-section]');
//     }

//     /**
//      * Wait for certificate data to be available and then load it
//      */
//     waitForCertificateData() {
//       if (window.coajd) {
//         this.loadCertificateData();
//       } else {
//         console.error('Certificate data not found. Make sure certificate-of-analysis-json-data.js.liquid is loaded.');
//       }
//     }

//     /**
//      * Load and parse certificate data from global variable
//      */
//     loadCertificateData() {
//       try {
//         if (window.coajd) {
//           this.certificateData = JSON.parse(window.coajd);
//           this.isDataLoaded = true;
//           //console.log(`Loaded ${this.certificateData.length} certificate records`);
//         } else {
//           console.error('Certificate data not found. Make sure certificate-of-analysis-json-data.js.liquid is loaded.');
//         }
//       } catch (error) {
//         console.error('Error parsing certificate data:', error);
//       }
//     }

//     /**
//      * Setup all event listeners
//      */
//     setupEventListeners() {
//       if (!this.searchInput) return;

//       this.setupInputEventListeners();
//       this.setupSearchButtonListener();
//     }

//     /**
//      * Setup input field event listeners
//      */
//     setupInputEventListeners() {
//       // Debounced input search
//       this.searchInput.addEventListener('input', (e) => {
//         this.handleInputChange(e.target.value.trim());
//       });

//       // Hide results when clicking outside
//       this.searchInput.addEventListener('blur', () => {
//         setTimeout(() => this.hideResults(), 200);
//       });

//       // Show results when focusing if there are results
//       this.searchInput.addEventListener('focus', () => {
//         this.handleInputFocus();
//       });

//       // Handle enter key press
//       this.searchInput.addEventListener('keypress', (e) => {
//         if (e.key === 'Enter') {
//           e.preventDefault();
//           this.handleSearch();
//         }
//       });
//     }

//     /**
//      * Setup search button event listener
//      */
//     setupSearchButtonListener() {
//       if (this.searchButton) {
//         this.searchButton.addEventListener('click', (e) => {
//           e.preventDefault();
//           this.handleSearch();
//         });
//       }
//     }

//     /**
//      * Handle input value changes with debouncing
//      * @param {string} query - Search query
//      */
//     handleInputChange(query) {
//       clearTimeout(this.searchTimeout);

//       // if (query.length < 2) {
//       //   this.hideResults();
//       //   return;
//       // }
//       this.hideResults();
//       this.searchTimeout = setTimeout(() => {
//         this.performSearch(query);
//       }, 300);
//     }

//     /**
//      * Handle input focus events
//      */
//     handleInputFocus() {
//       if (this.searchResults.children.length > 0) {
//         this.showResults();
//       }
//     }

//     /**
//      * Handle search button click or enter key press
//      */
//     handleSearch() {
//       const query = this.searchInput.value.trim();
//       if (query.length >= 2) {
//         this.performSearch(query);
//       }
//     }

//     /**
//      * Perform search using local certificate data
//      * @param {string} query - Search query
//      */
//     performSearch(query) {
//       if (!this.isDataLoaded) {
//         this.clearSearchResults();
//         this.renderNoResults('Certificate data is still loading...');
//         return;
//       }

//       try {
//         this.clearSearchResults();
//         this.showLoading();
//         const results = this.searchCertificates(query);

//         setTimeout(() => {
//           this.handleSearchResults(results);
//         }, 100);
//       } catch (error) {
//         console.error('Search error:', error);
//         this.clearSearchResults();
//         this.renderNoResults('An error occurred while searching.');
//       }
//     }

//     /**
//      * Handle search results display
//      * @param {Array} results - Search results
//      */
//     handleSearchResults(results) {
//       this.clearSearchResults();
//       if (results.length > 0) {
//         this.renderSearchResults(results);
//       } else {
//         this.renderNoResults();
//       }
//       this.showResults();
//     }

//     /**
//      * Search through certificate data
//      * @param {string} query - Search query
//      * @returns {Array} Filtered and sorted results
//      */
//     searchCertificates(query) {
//       const queryLower = query.toLowerCase();
//       const matches = this.findMatchingCertificates(queryLower);
//       const sorted = this.sortCertificatesByRelevance(matches, queryLower);

//       return sorted.slice(0, 12); // Increased limit to show more results
//     }

//     /**
//      * Find certificates matching the search query
//      * @param {string} queryLower - Lowercase search query
//      * @returns {Array} Matching certificates
//      */
//     findMatchingCertificates(queryLower) {
//       return this.certificateData.filter((cert) => {
//         const productNameMatch = cert.productName.toLowerCase().includes(queryLower);
//         const handleMatch = cert.productHandle.toLowerCase().includes(queryLower);
//         const lotNumberMatch = cert.lotNumber && cert.lotNumber.toLowerCase().includes(queryLower);
//         return productNameMatch || handleMatch || lotNumberMatch;
//       });
//     }

//     /**
//      * Sort certificates by relevance
//      * @param {Array} matches - Matching certificates
//      * @param {string} queryLower - Lowercase search query
//      * @returns {Array} Sorted certificates
//      */
//     sortCertificatesByRelevance(matches, queryLower) {
//       return matches.sort((a, b) => {
//         const aExact = a.productName.toLowerCase().startsWith(queryLower);
//         const bExact = b.productName.toLowerCase().startsWith(queryLower);

//         if (aExact && !bExact) return -1;
//         if (!aExact && bExact) return 1;

//         // Secondary sort by date (newest first)
//         if (a.date && b.date) {
//           return new Date(b.date) - new Date(a.date);
//         }

//         return a.productName.localeCompare(b.productName);
//       });
//     }

//     /**
//      * Show loading state
//      */
//     showLoading() {
//       const template = document.getElementById('search-loading-template');
//       if (template) {
//         const clone = template.content.cloneNode(true);
//         this.searchResults.appendChild(clone);
//       }
//       this.showResults();
//     }

//     /**
//      * Clear search results container
//      */
//     clearSearchResults() {
//       if (this.searchResults) {
//         this.searchResults.innerHTML = '';
//       }
//     }

//     /**
//      * Render search results with product data
//      * @param {Array} results - Array of certificate objects
//      */
//     renderSearchResults(results) {
//       const resultTemplate = this.getTemplate('search-result-item-template');
//       const dividerTemplate = this.getTemplate('search-result-divider-template');

//       if (!resultTemplate) return;

//       results.forEach((cert, index) => {
//         this.renderSingleResult(cert, resultTemplate);
//         this.addDividerIfNeeded(index, results.length, dividerTemplate);
//       });

//       this.setupResultClickListeners();
//     }

//     /**
//      * Get template by ID
//      * @param {string} templateId - Template ID
//      * @returns {HTMLTemplateElement|null} Template element
//      */
//     getTemplate(templateId) {
//       const template = document.getElementById(templateId);
//       if (!template) {
//         console.error(`Template not found: ${templateId}`);
//       }
//       return template;
//     }

//     /**
//      * Render a single search result
//      * @param {Object} cert - Certificate data
//      * @param {HTMLTemplateElement} template - Result template
//      */
//     renderSingleResult(cert, template) {
//       const productData = this.productService.getProductByHandle(cert.productHandle);
//       const clone = template.content.cloneNode(true);

//       this.populateResultData(clone, cert, productData);
//       this.setResultTitle(clone, cert, productData);
//       this.setResultImage(clone, cert, productData);
//       this.setResultDetails(clone, cert);

//       this.searchResults.appendChild(clone);
//     }

//     /**
//      * Populate result data attributes
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} cert - Certificate data
//      * @param {Object} productData - Product data
//      */
//     populateResultData(clone, cert, productData) {
//       const resultEl = clone.querySelector('.sb-third-party-testing__search-result');

//       resultEl.dataset.productHandle = cert.productHandle;
//       resultEl.dataset.productTitle = cert.productName;
//       resultEl.dataset.lotNumber = cert.lotNumber;
//       resultEl.dataset.pdfUrl = cert.pdfurl;
//       resultEl.dataset.analysisType = cert.AnalysisType;
//       resultEl.dataset.testDate = cert.date;
//       resultEl.dataset.productData = productData ? JSON.stringify(productData) : '';
//     }

//     /**
//      * Set result title
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} cert - Certificate data
//      * @param {Object} productData - Product data
//      */
//     setResultTitle(clone, cert, productData) {
//       const titleEl = clone.querySelector('[data-title]');
//       if (titleEl) {
//         const displayTitle = cert?.productName || productData?.title || 'Product';
//         titleEl.textContent = displayTitle;
//       }
//     }

//     /**
//      * Set result image
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} cert - Certificate data
//      * @param {Object} productData - Product data
//      */
//     setResultImage(clone, cert, productData) {
//       const imageContainer = clone.querySelector('[data-image-container]');
//       if (imageContainer && productData?.featured_image) {
//         const displayTitle = productData?.title || cert.productName;
//         const img = this.createProductImage(
//           productData.featured_image ||
//             '//cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081',
//           displayTitle
//         );
//         imageContainer.replaceWith(img);
//       }
//     }

//     /**
//      * Create product image element
//      * @param {string} imageSrc - Image source URL
//      * @param {string} altText - Alt text
//      * @returns {HTMLImageElement} Image element
//      */
//     createProductImage(imageSrc, altText) {
//       const img = document.createElement('img');
//       img.src = imageSrc;
//       img.alt = altText;
//       img.className = 'sb-third-party-testing__search-result-image';
//       img.loading = 'lazy';
//       return img;
//     }

//     /**
//      * Add divider between results if needed
//      * @param {number} index - Current index
//      * @param {number} totalLength - Total results length
//      * @param {HTMLTemplateElement} dividerTemplate - Divider template
//      */
//     addDividerIfNeeded(index, totalLength, dividerTemplate) {
//       if (index < totalLength - 1 && dividerTemplate) {
//         const dividerClone = dividerTemplate.content.cloneNode(true);
//         this.searchResults.appendChild(dividerClone);
//       }
//     }

//     /**
//      * Render no results message
//      * @param {string} message - Optional custom message
//      */
//     renderNoResults(message = 'No results found for your search.') {
//       const template = this.getTemplate('search-no-results-template');
//       if (template) {
//         const clone = template.content.cloneNode(true);
//         this.setNoResultsMessage(clone, message);
//         this.searchResults.appendChild(clone);
//       }
//     }

//     /**
//      * Set no results message text
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {string} message - Message text
//      */
//     setNoResultsMessage(clone, message) {
//       const messageEl = clone.querySelector('[data-message]');
//       if (messageEl) {
//         messageEl.textContent = message;
//       }
//     }

//     /**
//      * Setup click listeners for search results
//      */
//     setupResultClickListeners() {
//       const results = this.searchResults.querySelectorAll('.sb-third-party-testing__search-result');
//       results.forEach((result) => {
//         result.addEventListener('click', (e) => {
//           const certificateData = this.extractCertificateData(e.currentTarget);
//           this.handleCertificateSelection(certificateData);
//         });
//       });
//     }

//     /**
//      * Extract certificate data from DOM element
//      * @param {HTMLElement} element - DOM element with data attributes
//      * @returns {Object} Certificate data object
//      */
//     extractCertificateData(element) {
//       return {
//         handle: element.dataset.productHandle,
//         title: element.dataset.productTitle,
//         lotNumber: element.dataset.lotNumber,
//         pdfUrl: element.dataset.pdfUrl,
//         analysisType: element.dataset.analysisType,
//         testDate: element.dataset.testDate,
//       };
//     }

//     /**
//      * Handle selection of a certificate from search results
//      * @param {Object} certificate - Certificate data object
//      */
//     handleCertificateSelection(certificate) {
//       this.storeCertificateData(certificate);
//       this.addToSearchHistory(certificate);
//       this.displayRecentProduct(certificate);
//       this.openCertificateInModal(certificate.pdfUrl);
//       this.clearSearchState();
//     }

//     /**
//      * Store certificate data in localStorage
//      * @param {Object} certificate - Certificate data object
//      */
//     storeCertificateData(certificate) {
//       localStorage.setItem('td_recent_product', JSON.stringify(certificate));
//     }

//     /**
//      * Open certificate PDF in modal using PDF.js
//      * @param {string} pdfUrl - PDF URL
//      */
//     openCertificateInModal(pdfUrl) {
//       if (!this.modalId) {
//         // Fallback to opening in new tab if no modal is available
//         window.open(pdfUrl, '_blank');
//         return;
//       }

//       // Get the PDF viewer template
//       const pdfTemplate = document.getElementById('sb-pdf-viewer-template');
//       if (!pdfTemplate) {
//         console.error('PDF viewer template not found');
//         window.open(pdfUrl, '_blank');
//         return;
//       }

//       // Convert the template clone to HTML string
//       const tempContainer = document.createElement('div');
//       const clone = pdfTemplate.content.cloneNode(true);
//       tempContainer.appendChild(clone);

//       // Dispatch event to update modal with the viewer HTML
//       document.dispatchEvent(
//         new CustomEvent('sb-modal:update', {
//           detail: {
//             modalId: this.modalId,
//             heading: 'Certificate of Analysis',
//             children: tempContainer.innerHTML,
//           },
//         })
//       );

//       // Open the modal
//       document.dispatchEvent(
//         new CustomEvent('sb-modal:open', {
//           detail: {
//             modalId: this.modalId,
//           },
//         })
//       );

//       // Initialize PDF.js once the modal is opened and elements are in the DOM
//       this.initPdfViewer(pdfUrl);
//     }

//     /**
//      * Initialize PDF.js viewer with optimized high-resolution rendering
//      * @param {string} pdfUrl - PDF URL
//      */
//     async initPdfViewer(pdfUrl) {
//       // Check if PDF.js is available
//       if (!window.pdfjsLib) {
//         console.error('PDF.js library not found');
//         window.open(pdfUrl, '_blank');
//         // Show close button so user can close the modal
//         this.showCloseButton();
//         return;
//       }

//       // Wait a bit for the modal to be fully in the DOM
//       setTimeout(async () => {
//         const container = document.querySelector('.sb-modal__body .sb-pdf-viewer__container');

//         if (!container) {
//           console.error('PDF container not found in modal');
//           // Show close button so user can close the modal
//           this.showCloseButton();
//           return;
//         }

//         try {
//           // Load the PDF document
//           const loadingTask = window.pdfjsLib.getDocument(pdfUrl);
//           const pdf = await loadingTask.promise;

//           // Get the first page
//           const page = await pdf.getPage(1);

//           // Remove loading indicator
//           const loadingElement = container.querySelector('.sb-pdf-viewer__loading');
//           if (loadingElement) loadingElement.remove();

//           // This page's own intrinsic size/orientation — pulled straight from
//           // its MediaBox, so it's already correct whether the source PDF is
//           // US Letter, A4, legal, or landscape. Nothing here needs to "detect"
//           // page size; it's inherent to viewport.
//           const containerWidth = container.clientWidth - 40; // Some margin
//           const viewport = page.getViewport({ scale: 1 });
//           const pageAspectRatio = viewport.height / viewport.width;
//           const devicePixelRatio = window.devicePixelRatio || 1;

//           // Detect screen size for optimized scaling
//           const isLargeScreen = window.innerWidth >= 1024; // Desktop/tablet landscape
//           const isHighDPI = devicePixelRatio > 1;

//           // Calculate base scale to fit container width
//           const baseScale = containerWidth / viewport.width;

//           // Enhanced scaling strategy for different screen sizes
//           let renderScale;
//           let maxScale;

//           if (isLargeScreen) {
//             // Large screens: prioritize quality, especially on high DPI displays
//             const minScale = isHighDPI ? 1.5 : 1.0; // Higher minimum for large screens
//             maxScale = isHighDPI ? 4.0 : 3.0; // Allow higher scaling on high DPI

//             // For large screens, use more aggressive scaling for quality
//             const qualityMultiplier = isHighDPI ? 2.0 : 1.5;
//             renderScale = Math.min(maxScale, Math.max(minScale, baseScale * devicePixelRatio * qualityMultiplier));
//           } else {
//             // Small screens: balance quality and performance
//             const minScale = 0.8; // Minimum scale to maintain quality
//             maxScale = 2.5; // Conservative max for mobile performance

//             // Use standard scaling for mobile devices
//             renderScale = Math.min(maxScale, Math.max(minScale, baseScale * devicePixelRatio));
//           }

//           // Create viewport for rendering (high resolution)
//           const renderViewport = page.getViewport({ scale: renderScale });

//           // Display size derived from THIS page's own aspect ratio, capped to
//           // the available container width. Setting this as explicit inline px
//           // (rather than relying on height:auto) is what prevents the cutoff —
//           // it can't be overridden by a fixed-size CSS rule elsewhere that
//           // assumes a Letter-shaped box.
//           const displayWidth = Math.min(containerWidth, viewport.width * baseScale);
//           const displayHeight = displayWidth * pageAspectRatio;

//           // Create canvas with optimized resolution
//           const canvas = document.createElement('canvas');
//           canvas.className = 'sb-pdf-viewer__canvas';

//           // Set canvas size for high-DPI rendering
//           canvas.width = renderViewport.width;
//           canvas.height = renderViewport.height;

//           // Style the canvas for proper display — explicit px, not height:auto
//           canvas.style.width = `${displayWidth}px`;
//           canvas.style.height = `${displayHeight}px`;
//           canvas.style.maxWidth = '100%';
//           canvas.style.display = 'block';
//           canvas.style.marginLeft = 'auto';
//           canvas.style.marginRight = 'auto';

//           // For large screens with high DPI, apply additional sharpening
//           if (isLargeScreen && isHighDPI) {
//             canvas.style.imageRendering = 'crisp-edges';
//             canvas.style.imageRendering = '-webkit-crisp-edges';
//           }

//           // Add canvas to container
//           container.appendChild(canvas);

//           // Get context and configure for high-DPI
//           const ctx = canvas.getContext('2d');

//           // Enable high-quality rendering
//           ctx.imageSmoothingEnabled = true;
//           ctx.imageSmoothingQuality = 'high';

//           // Render PDF page at optimized resolution
//           const renderContext = {
//             canvasContext: ctx,
//             viewport: renderViewport,
//           };

//           await page.render(renderContext).promise;

//           // Show close button after PDF has loaded successfully
//           this.showCloseButton();
//         } catch (err) {
//           console.error('Error rendering PDF:', err);
//           container.innerHTML = `
//           <div style="padding: 20px; text-align: center;">
//             <p>Unable to load PDF. <a href="${pdfUrl}" target="_blank" rel="noopener noreferrer">Open PDF in new tab</a></p>
//           </div>
//         `;

//           // Show close button even if PDF loading fails
//           this.showCloseButton();
//         }
//       }, 300); // Give the modal time to open
//     }

//     /**
//      * Show the close button in the PDF viewer modal
//      */
//     showCloseButton() {
//       const closeButton = document.querySelector('.sb-pdf-viewer__close');
//       if (closeButton) {
//         closeButton.style.display = 'flex';
//       }
//     }

//     /**
//      * Clear search input and hide results
//      */
//     clearSearchState() {
//       this.hideResults();
//       // this.searchInput.value = '';
//     }

//     /**
//      * Add search to history
//      * @param {Object} certificate - Certificate data object
//      */
//     addToSearchHistory(certificate) {
//       let searchHistory = this.getSearchHistory();
//       const searchEntry = this.createSearchHistoryEntry(certificate);

//       console.log(certificate);
//       searchHistory = this.removeDuplicateHistoryEntries(searchHistory, certificate.pdfUrl);
//       searchHistory = this.addAndLimitHistory(searchHistory, searchEntry);

//       this.saveSearchHistory(searchHistory);
//       this.refreshSearchHistory();
//     }

//     /**
//      * Get search history from localStorage
//      * @returns {Array} Search history array
//      */
//     getSearchHistory() {
//       return JSON.parse(localStorage.getItem('td_search_history') || '[]');
//     }

//     /**
//      * Create search history entry
//      * @param {Object} certificate - Certificate data object
//      * @returns {Object} Search history entry
//      */
//     createSearchHistoryEntry(certificate) {
//       return {
//         date: new Date().toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }),
//         productName: certificate.title,
//         testType: certificate.analysisType,
//         handle: certificate.handle,
//         image: this.productService.getProductByHandle(certificate.handle)?.featured_image || '',
//         pdfUrl: certificate.pdfUrl,
//         timestamp: Date.now(),
//       };
//     }

//     /**
//      * Remove duplicate entries for the same product
//      * @param {Array} searchHistory - Current search history
//      * @param {string} productName - Product name to remove duplicates for
//      * @returns {Array} Filtered search history
//      */
//     removeDuplicateHistoryEntries(searchHistory, pdfUrl) {
//       return searchHistory.filter((item) => item.pdfUrl !== pdfUrl);
//     }

//     /**
//      * Add new entry and limit history size
//      * @param {Array} searchHistory - Current search history
//      * @param {Object} searchEntry - New search entry
//      * @returns {Array} Updated search history
//      */
//     addAndLimitHistory(searchHistory, searchEntry) {
//       searchHistory.unshift(searchEntry);
//       return searchHistory.slice(0, 10);
//     }

//     /**
//      * Save search history to localStorage
//      * @param {Array} searchHistory - Search history to save
//      */
//     saveSearchHistory(searchHistory) {
//       localStorage.setItem('td_search_history', JSON.stringify(searchHistory));
//     }

//     /**
//      * Load and display search history
//      */
//     loadSearchHistory() {
//       this.refreshSearchHistory();
//     }

//     /**
//      * Refresh and display the entire search history
//      * Replaces displaySearchHistory() to ensure full UI update
//      */
//     refreshSearchHistory() {
//       if (!this.searchHistoryList) return;

//       const searchHistory = this.getSearchHistory();
//       const searchHistorySection = document.querySelector('.sb-third-party-testing__search-history');

//       if (searchHistory.length === 0) {
//         this.hideSearchHistorySection(searchHistorySection);
//         return;
//       }

//       this.showSearchHistorySection(searchHistorySection);
//       this.renderSearchHistoryItems(searchHistory);
//     }

//     /**
//      * Display search history in the sidebar
//      * @deprecated Use refreshSearchHistory() instead
//      */
//     displaySearchHistory() {
//       this.refreshSearchHistory();
//     }

//     /**
//      * Hide search history section
//      * @param {HTMLElement} section - Search history section element
//      */
//     hideSearchHistorySection(section) {
//       if (section) {
//         section.style.display = 'none';
//       }
//     }

//     /**
//      * Show search history section
//      * @param {HTMLElement} section - Search history section element
//      */
//     showSearchHistorySection(section) {
//       if (section) {
//         section.style.display = 'flex';
//       }
//     }

//     /**
//      * Render search history items
//      * @param {Array} searchHistory - Search history array
//      */
//     renderSearchHistoryItems(searchHistory) {
//       const template = this.getTemplate('search-history-item-template');
//       if (!template) return;

//       this.searchHistoryList.innerHTML = '';

//       searchHistory.forEach((item) => {
//         const clone = template.content.cloneNode(true);
//         this.populateSearchHistoryItem(clone, item);
//         this.searchHistoryList.appendChild(clone);
//       });
//     }

//     /**
//      * Populate search history item data
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} item - History item data
//      */
//     populateSearchHistoryItem(clone, item) {
//       clone.querySelectorAll('[data-date]').forEach((el) => (el.textContent = item.date));
//       clone.querySelectorAll('[data-product-name]').forEach((el) => (el.textContent = item.productName));
//       clone.querySelectorAll('[data-test-type]').forEach((el) => (el.textContent = item.testType));

//       const imgMount = clone.querySelector('[data-history-image]');
//       if (imgMount) {
//         let imageSrc = item.image || '';
//         if (!imageSrc && item.handle) {
//           const productData = this.productService.getProductByHandle(item.handle);
//           imageSrc = productData?.featured_image || '';
//         }

//         if (imageSrc) {
//           const img = document.createElement('img');
//           img.className = 'sb-third-party-testing__search-history-thumb-img sb-only-desktop';
//           img.alt = item.productName || 'Product image';
//           img.loading = 'lazy';
//           img.src = imageSrc;
//           imgMount.replaceWith(img);
//         } else {
//           // Keep mount as a subtle placeholder block
//           imgMount.classList.add('sb-third-party-testing__search-history-thumb-img');
//           imgMount.style.backgroundColor = '#f0f2f5';
//         }
//       }

//       const linkEl = clone.querySelector('[data-pdf-link]');
//       linkEl.href = 'javascript:void(0);'; // Prevent default navigation
//       linkEl.removeAttribute('target');

//       // Add click event to open in modal instead
//       linkEl.addEventListener('click', (e) => {
//         e.preventDefault();
//         this.openCertificateInModal(item.pdfUrl);
//       });
//     }

//     /**
//      * Display recent product in the main section
//      * @param {Object} certificate - Certificate data object
//      */
//     displayRecentProduct(certificate) {
//       if (!this.recentProductContainer || !this.recentProductContent) return;

//       const template = this.getTemplate('recent-product-template');
//       if (!template) return;

//       if (this.recentTitle) {
//         this.recentTitle.classList.remove('sb-third-party-testing__recent-title--hidden');
//       }

//       const clone = template.content.cloneNode(true);
//       const productData = this.productService.getProductByHandle(certificate.handle);
//       console.log('Displaying recent product:', certificate, productData);
//       this.setRecentProductImage(clone, certificate, productData);
//       this.setRecentProductTitle(clone, certificate, productData);
//       this.setRecentProductDescription(clone, certificate, productData);
//       this.setRecentProductLink(clone, certificate);
//       this.displayRecentProductContent(clone);
//     }

//     /**
//      * Set recent product image
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} certificate - Certificate data
//      * @param {Object} productData - Product data
//      */
//     setRecentProductImage(clone, certificate, productData) {
//       const imageEl = clone.querySelector('[data-image]');
//       if (productData?.featured_image) {
//         const img = document.createElement('img');
//         img.src = productData.featured_image;
//         img.alt = certificate.title;
//         img.className = 'sb-third-party-testing__recent-image';
//         img.loading = 'lazy';
//         imageEl.replaceWith(img);
//       } else {
//         imageEl.style.backgroundColor = '#f8f9fb';
//       }
//     }

//     /**
//      * Set recent product title
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} certificate - Certificate data
//      * @param {Object} productData - Product data
//      */
//     setRecentProductTitle(clone, certificate, productData) {
//       const displayTitle = productData?.title || certificate.title;
//       clone.querySelector('[data-title]').textContent = displayTitle;
//     }

//     /**
//      * Set recent product description
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} certificate - Certificate data
//      * @param {Object} productData - Product data
//      */
//     setRecentProductDescription(clone, certificate, productData) {
//       const description = this.getProductDescription(certificate, productData);
//       const cleanLimitedText = this.cleanAndLimitText(description, 18);
//       clone.querySelector('[data-description]').textContent = cleanLimitedText;
//     }

//     /**
//      * Get product description from various sources
//      * @param {Object} certificate - Certificate data
//      * @param {Object} productData - Product data
//      * @returns {string} Description text
//      */
//     getProductDescription(certificate, productData) {
//       if (productData?.description) {
//         if (productData.metafields?.plp_product_short_description) {
//           return productData.metafields.plp_product_short_description;
//         }
//         return productData.description;
//       }
//       return `Lot Number: ${certificate.lotNumber} | Test Type: ${certificate.analysisType} | Date: ${certificate.testDate}`;
//     }

//     /**
//      * Clean HTML and limit text to specified word count
//      * @param {string} text - Text to clean and limit
//      * @param {number} wordLimit - Maximum number of words
//      * @returns {string} Clean, limited text
//      */
//     cleanAndLimitText(text, wordLimit) {
//       const tempDiv = document.createElement('div');
//       tempDiv.innerHTML = text;
//       const cleanText = tempDiv.textContent || tempDiv.innerText || '';
//       return cleanText.split(' ').slice(0, wordLimit).join(' ');
//     }

//     /**
//      * Set recent product link
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} certificate - Certificate data
//      */
//     setRecentProductLink(clone, certificate) {
//       const productUrl = `/products/${certificate.handle}`;

//       // Set href on the content wrapper link
//       const contentLinkEl = clone.querySelector('[data-content-link]');
//       if (contentLinkEl) {
//         contentLinkEl.href = productUrl;
//       }
//     }

//     /**
//      * Display recent product content
//      * @param {DocumentFragment} clone - Cloned template content
//      */
//     displayRecentProductContent(clone) {
//       this.recentProductContent.innerHTML = '';
//       this.recentProductContent.appendChild(clone);
//       this.recentProductContainer.classList.add('sb-third-party-testing__recent-product--visible');
//     }

//     /**
//      * Load and display the most recent product
//      */
//     loadRecentProduct() {
//       const recentProduct = localStorage.getItem('td_recent_product');
//       if (recentProduct) {
//         try {
//           const productData = JSON.parse(recentProduct);
//           this.displayRecentProduct(productData);
//         } catch (error) {
//           console.error('Error loading recent product:', error);
//         }
//       }
//     }

//     /**
//      * Show search results dropdown
//      */
//     showResults() {
//       if (this.searchResults) {
//         this.searchResults.classList.add('sb-third-party-testing__search-results--visible');
//       }
//     }

//     /**
//      * Hide search results dropdown
//      */
//     hideResults() {
//       if (this.searchResults) {
//         this.searchResults.classList.remove('sb-third-party-testing__search-results--visible');
//       }
//     }

//     /**
//      * Set result details (test type and date)
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} cert - Certificate data
//      */
//     setResultDetails(clone, cert) {
//       // const lotEl = clone.querySelector('[data-lot-number-child]');
//       const typeEl = clone.querySelector('[data-analysis-display-child]');
//       const dateEl = clone.querySelector('[data-test-date-child]');

//       // // // Set lot number
//       // if (lotEl && cert.lotNumber) {
//       //   lotEl.textContent = `Lot: ${cert.lotNumber}`;
//       // }

//       // Set test type - try both camelCase and PascalCase property names
//       if (typeEl) {
//         const analysisType = cert.analysisType || cert.AnalysisType;
//         typeEl.textContent = analysisType || 'Test';
//       }

//       // Set date
//       if (dateEl && cert.date) {
//         try {
//           const testDate = new Date(cert.date);
//           dateEl.textContent = testDate.toLocaleDateString('en-US', {
//             month: 'numeric',
//             day: 'numeric',
//             year: 'numeric',
//           });
//         } catch (e) {
//           dateEl.textContent = cert.date;
//         }
//       }
//     }
//   }

//   // Register the custom element
//   customElements.define('sb-product-search', TdProductSearch);
// }


// /**
//  * TdProductSearch Web Component
//  * Handles product search for third-party testing certificates using local JSON data
//  *
//  * Besides the direct matches, search results include the most recently tested
//  * certificate of every parent product that appears in the results. Searching
//  * "Sour Grape" shows Creatine HMB - Sour Grape plus the newest Creatine HMB
//  * certificate, whichever flavor that currently is.
//  *
//  * @class TdProductSearch
//  * @extends HTMLElement
//  */

// // Everything lives inside this guard so that loading the script twice
// // does not throw "Identifier has already been declared".
// if (!customElements.get('sb-product-search')) {
//   /* ---------------------------------------------------------------------------
//    * Configuration
//    * ------------------------------------------------------------------------- */

//   /** Minimum number of characters before a search runs */
//   const MIN_QUERY_LENGTH = 2;

//   /** Maximum number of direct matches shown (parent "latest" results are added on top) */
//   const MAX_RESULTS = 12;

//   /**
//    * Analysis type preferred when choosing a parent product's most recent result.
//    * A record of this type always wins over other types (e.g. Gluten) for the
//    * "most recently tested" slot. Set to '' to treat every analysis type equally.
//    */
//   const PREFERRED_LATEST_ANALYSIS_TYPE = 'COA';

//   /**
//    * Some records in the certificate data use inconsistent product handles.
//    * These aliases group them under one parent product. They are only used for
//    * grouping; links still use each record's own handle.
//    */
//   const PARENT_HANDLE_ALIASES = {
//     '-bcaa-powder': 'bcaa-powder',
//     '-post-workout': 'post-workout',
//     '-workout': 'intra-workout',
//     'lean-preworkout': 'lean-pre-workout',
//   };

//   /* ---------------------------------------------------------------------------
//    * Certificate data helpers
//    * ------------------------------------------------------------------------- */

//   /**
//    * Parse a certificate date in MM-DD-YYYY format.
//    * new Date('05-29-2026') is not reliable across browsers (Safari rejects it),
//    * so the parts are read manually. Returns a timestamp, or null if invalid.
//    * @param {string} value - Date string from the certificate data
//    * @returns {number|null} Timestamp or null
//    */
//   function parseCertificateDate(value) {
//     // The day allows up to 3 digits to tolerate zero-padded typos like "05-013-2025"
//     const match = String(value || '')
//       .trim()
//       .match(/^(\d{1,2})-(\d{1,3})-(\d{4})$/);
//     if (!match) return null;

//     const month = Number(match[1]);
//     const day = Number(match[2]);
//     const year = Number(match[3]);
//     const date = new Date(year, month - 1, day);

//     const isRealDate = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
//     return isRealDate ? date.getTime() : null;
//   }

//   /**
//    * Format a timestamp as M/D/YYYY
//    * @param {number} timestamp - Timestamp
//    * @returns {string} Formatted date
//    */
//   function formatCertificateDate(timestamp) {
//     const date = new Date(timestamp);
//     return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
//   }

//   /**
//    * Display text for a certificate's date
//    * @param {Object} cert - Prepared certificate
//    * @returns {string} Display date
//    */
//   function getDisplayDate(cert) {
//     return cert.timestamp !== null ? formatCertificateDate(cert.timestamp) : cert.date;
//   }

//   /**
//    * Get the parent product key used to group flavors together
//    * @param {string} handle - Product handle from the certificate data
//    * @returns {string} Parent key
//    */
//   function getParentKey(handle) {
//     const key = String(handle || '')
//       .trim()
//       .toLowerCase();
//     return PARENT_HANDLE_ALIASES[key] || key;
//   }

//   /**
//    * Split a lot number into [YYMMDD, sequence] for tie-breaking.
//    * Lot numbers vary in length (e.g. 26051332 vs 260415114), so comparing
//    * them as whole numbers would be wrong.
//    * @param {string} lotNumber - Lot number
//    * @returns {Array<number>} Sort key
//    */
//   function getLotSortKey(lotNumber) {
//     const digits = String(lotNumber || '').replace(/\D/g, '');
//     return [Number(digits.slice(0, 6)) || 0, Number(digits.slice(6)) || 0];
//   }

//   /**
//    * Whether certificate a is more recent than certificate b.
//    * Compares test dates first; on the same date, the later lot wins.
//    * @param {Object} a - Prepared certificate
//    * @param {Object} b - Prepared certificate
//    * @returns {boolean} True if a is newer
//    */
//   function isNewerCertificate(a, b) {
//     if (a.timestamp !== b.timestamp) return a.timestamp > b.timestamp;

//     const [aDate, aSequence] = getLotSortKey(a.lotNumber);
//     const [bDate, bSequence] = getLotSortKey(b.lotNumber);
//     if (aDate !== bDate) return aDate > bDate;
//     return aSequence > bSequence;
//   }

//   /**
//    * Clean up raw certificate records: trim fields, drop exact duplicates,
//    * and precompute the values used for searching and grouping.
//    * @param {Array<Object>} rawRecords - Records parsed from window.coajd
//    * @returns {Array<Object>} Prepared certificates
//    */
//   function prepareCertificates(rawRecords) {
//     const seen = new Set();
//     const prepared = [];

//     rawRecords.forEach((raw) => {
//       if (!raw || typeof raw !== 'object') return;

//       const cert = {
//         ...raw,
//         productName: String(raw.productName || '').trim(),
//         productHandle: String(raw.productHandle || '').trim(),
//         lotNumber: String(raw.lotNumber || '').trim(),
//         AnalysisType: String(raw.AnalysisType || '').trim(),
//         pdfurl: String(raw.pdfurl || '').trim(),
//         date: String(raw.date || '').trim(),
//       };

//       const duplicateKey = [cert.productName, cert.lotNumber, cert.AnalysisType, cert.pdfurl].join('|');
//       if (seen.has(duplicateKey)) return;
//       seen.add(duplicateKey);

//       cert.parentKey = getParentKey(cert.productHandle);
//       cert.timestamp = parseCertificateDate(cert.date);
//       cert.searchFields = [cert.productName, cert.productHandle, cert.lotNumber].map((field) => field.toLowerCase());

//       prepared.push(cert);
//     });

//     return prepared;
//   }

//   /**
//    * Find the most recently tested certificate for each parent product
//    * @param {Array<Object>} certificates - Prepared certificates
//    * @returns {Map<string, Object>} Parent key -> most recent certificate
//    */
//   function buildLatestByParent(certificates) {
//     const latestByParent = new Map();
//     const preferredType = PREFERRED_LATEST_ANALYSIS_TYPE.toLowerCase();

//     certificates.forEach((cert) => {
//       // Records without a usable date can't be ranked
//       if (!cert.parentKey || cert.timestamp === null) return;

//       const current = latestByParent.get(cert.parentKey);
//       if (!current) {
//         latestByParent.set(cert.parentKey, cert);
//         return;
//       }

//       if (preferredType) {
//         const certIsPreferred = cert.AnalysisType.toLowerCase() === preferredType;
//         const currentIsPreferred = current.AnalysisType.toLowerCase() === preferredType;
//         if (certIsPreferred !== currentIsPreferred) {
//           if (certIsPreferred) latestByParent.set(cert.parentKey, cert);
//           return;
//         }
//       }

//       if (isNewerCertificate(cert, current)) {
//         latestByParent.set(cert.parentKey, cert);
//       }
//     });

//     return latestByParent;
//   }

//   /**
//    * Simple service class for accessing pre-rendered product data
//    */
//   class ProductDataService {
//     constructor() {
//       this.productData = {};
//       this.isDataLoaded = false;
//       this.waitForProductData();
//     }

//     /**
//      * Wait for product data to be available
//      */
//     waitForProductData() {
//       if (window.tdProductData) {
//         this.productData = window.tdProductData;
//         this.isDataLoaded = true;
//         //console.log(`Loaded product data for ${Object.keys(this.productData).length} products`);
//       } else {
//         console.error('Product data not found. Make sure sb-product-data-map.js.liquid is loaded.');
//       }
//     }

//     /**
//      * Get product data by handle (synchronous)
//      * @param {string} handle - Product handle
//      * @returns {Object|null} Product data or null if not found
//      */
//     getProductByHandle(handle) {
//       if (!this.isDataLoaded) {
//         console.warn('Product data not yet loaded');
//         return null;
//       }

//       return this.productData[handle] || null;
//     }

//     /**
//      * Get multiple products by handles (synchronous)
//      * @param {Array<string>} handles - Array of product handles
//      * @returns {Array<Object>} Array of product data
//      */
//     getProductsBatch(handles) {
//       return handles.map((handle) => this.getProductByHandle(handle)).filter(Boolean);
//     }

//     /**
//      * Check if product data is loaded
//      * @returns {boolean} True if data is loaded
//      */
//     isLoaded() {
//       return this.isDataLoaded;
//     }
//   }

//   class TdProductSearch extends HTMLElement {
//     constructor() {
//       super();
//       this.searchInput = null;
//       this.searchResults = null;
//       this.searchButton = null;
//       this.searchTimeout = null;
//       this.recentProductContainer = null;
//       this.recentProductContent = null;
//       this.searchHistoryList = null;
//       this.recentSection = null;
//       this.searchHistorySection = null;
//       this.certificateData = [];
//       this.latestByParent = new Map();
//       this.isDataLoaded = false;
//       this.productService = new ProductDataService();
//       this.modalId = null;
//     }

//     connectedCallback() {
//       this.initializeElements();
//       this.waitForCertificateData();
//       this.setupEventListeners();
//       this.initializeDataDependentSections();
//       this.modalId = this.getAttribute('data-modal-id');
//     }

//     /**
//      * Initialize sections that depend on data being loaded
//      */
//     initializeDataDependentSections() {
//       // Only load and show sections if both product and certificate data are available
//       if (this.productService.isLoaded() && this.isDataLoaded) {
//         this.loadRecentProduct();
//         this.loadSearchHistory();
//         this.showDataDependentSections();
//       } else {
//         // Wait a bit and try again
//         setTimeout(() => this.initializeDataDependentSections(), 100);
//       }
//     }

//     /**
//      * Show the sections that depend on data being loaded
//      */
//     showDataDependentSections() {
//       if (this.recentSection) {
//         this.recentSection.classList.add('sb-third-party-testing__recent-section--visible');
//       }
//       if (this.searchHistorySection) {
//         this.searchHistorySection.classList.add('sb-third-party-testing__search-history--visible');
//       }
//     }

//     /**
//      * Initialize DOM element references
//      */
//     initializeElements() {
//       this.searchInput = this.querySelector('[data-search-input]');
//       this.searchResults = this.querySelector('[data-search-results]');
//       this.searchButton = this.querySelector('[data-search-button]');
//       this.recentTitle = document.querySelector('[data-recent-title]');
//       this.recentProductContainer = document.querySelector('[data-recent-product]');
//       this.recentProductContent = document.querySelector('[data-recent-content]');
//       this.searchHistoryList = document.querySelector('[data-search-history-list]');
//       this.recentSection = document.querySelector('[data-recent-section]');
//       this.searchHistorySection = document.querySelector('[data-search-history-section]');
//     }

//     /**
//      * Wait for certificate data to be available and then load it
//      */
//     waitForCertificateData() {
//       if (window.coajd) {
//         this.loadCertificateData();
//       } else {
//         console.error('Certificate data not found. Make sure certificate-of-analysis-json-data.js.liquid is loaded.');
//       }
//     }

//     /**
//      * Load and parse certificate data from global variable
//      */
//     loadCertificateData() {
//       try {
//         if (window.coajd) {
//           const parsed = JSON.parse(window.coajd);
//           this.certificateData = prepareCertificates(Array.isArray(parsed) ? parsed : []);
//           this.latestByParent = buildLatestByParent(this.certificateData);
//           this.isDataLoaded = true;
//           //console.log(`Loaded ${this.certificateData.length} certificate records`);
//         } else {
//           console.error('Certificate data not found. Make sure certificate-of-analysis-json-data.js.liquid is loaded.');
//         }
//       } catch (error) {
//         console.error('Error parsing certificate data:', error);
//       }
//     }

//     /**
//      * Setup all event listeners
//      */
//     setupEventListeners() {
//       if (!this.searchInput) return;

//       this.setupInputEventListeners();
//       this.setupSearchButtonListener();
//     }

//     /**
//      * Setup input field event listeners
//      */
//     setupInputEventListeners() {
//       // Debounced input search
//       this.searchInput.addEventListener('input', (e) => {
//         this.handleInputChange(e.target.value.trim());
//       });

//       // Hide results when clicking outside
//       this.searchInput.addEventListener('blur', () => {
//         setTimeout(() => this.hideResults(), 200);
//       });

//       // Show results when focusing if there are results
//       this.searchInput.addEventListener('focus', () => {
//         this.handleInputFocus();
//       });

//       // Handle enter key press
//       this.searchInput.addEventListener('keypress', (e) => {
//         if (e.key === 'Enter') {
//           e.preventDefault();
//           this.handleSearch();
//         }
//       });
//     }

//     /**
//      * Setup search button event listener
//      */
//     setupSearchButtonListener() {
//       if (this.searchButton) {
//         this.searchButton.addEventListener('click', (e) => {
//           e.preventDefault();
//           this.handleSearch();
//         });
//       }
//     }

//     /**
//      * Handle input value changes with debouncing
//      * @param {string} query - Search query
//      */
//     handleInputChange(query) {
//       clearTimeout(this.searchTimeout);
//       this.hideResults();

//       // Too short to search: clear old results so focusing the input doesn't show them again
//       if (query.length < MIN_QUERY_LENGTH) {
//         this.clearSearchResults();
//         return;
//       }

//       this.searchTimeout = setTimeout(() => {
//         this.performSearch(query);
//       }, 300);
//     }

//     /**
//      * Handle input focus events
//      */
//     handleInputFocus() {
//       if (this.searchResults.children.length > 0) {
//         this.showResults();
//       }
//     }

//     /**
//      * Handle search button click or enter key press
//      */
//     handleSearch() {
//       const query = this.searchInput.value.trim();
//       if (query.length >= MIN_QUERY_LENGTH) {
//         clearTimeout(this.searchTimeout);
//         this.performSearch(query);
//       }
//     }

//     /**
//      * Perform search using local certificate data
//      * @param {string} query - Search query
//      */
//     performSearch(query) {
//       if (!this.isDataLoaded) {
//         this.clearSearchResults();
//         this.renderNoResults('Certificate data is still loading...');
//         return;
//       }

//       try {
//         this.clearSearchResults();
//         this.showLoading();
//         const results = this.searchCertificates(query);

//         setTimeout(() => {
//           this.handleSearchResults(results);
//         }, 100);
//       } catch (error) {
//         console.error('Search error:', error);
//         this.clearSearchResults();
//         this.renderNoResults('An error occurred while searching.');
//       }
//     }

//     /**
//      * Handle search results display
//      * @param {Array} results - Search result entries
//      */
//     handleSearchResults(results) {
//       this.clearSearchResults();
//       if (results.length > 0) {
//         this.renderSearchResults(results);
//       } else {
//         this.renderNoResults();
//       }
//       this.showResults();
//     }

//     /**
//      * Search through certificate data
//      * @param {string} query - Search query
//      * @returns {Array<{cert: Object, isLatestForParent: boolean}>} Result entries
//      */
//     searchCertificates(query) {
//       const queryLower = query.trim().toLowerCase();
//       if (queryLower.length < MIN_QUERY_LENGTH) return [];

//       const matches = this.findMatchingCertificates(queryLower);
//       const sorted = this.sortCertificatesByRelevance(matches, queryLower).slice(0, MAX_RESULTS);

//       return this.addLatestParentResults(sorted);
//     }

//     /**
//      * Find certificates matching the search query
//      * @param {string} queryLower - Lowercase search query
//      * @returns {Array} Matching certificates
//      */
//     findMatchingCertificates(queryLower) {
//       return this.certificateData.filter((cert) => cert.searchFields.some((field) => field.includes(queryLower)));
//     }

//     /**
//      * Sort certificates by relevance
//      * @param {Array} matches - Matching certificates
//      * @param {string} queryLower - Lowercase search query
//      * @returns {Array} Sorted certificates
//      */
//     sortCertificatesByRelevance(matches, queryLower) {
//       return matches.sort((a, b) => {
//         const aExact = a.searchFields[0].startsWith(queryLower);
//         const bExact = b.searchFields[0].startsWith(queryLower);

//         if (aExact && !bExact) return -1;
//         if (!aExact && bExact) return 1;

//         // Secondary sort by date (newest first); records without a valid date go last
//         const aTime = a.timestamp !== null ? a.timestamp : -Infinity;
//         const bTime = b.timestamp !== null ? b.timestamp : -Infinity;
//         if (aTime !== bTime) return bTime - aTime;

//         // Same date: later lot first, matching how the most recent certificate is chosen
//         if (isNewerCertificate(a, b)) return -1;
//         if (isNewerCertificate(b, a)) return 1;

//         return a.productName.localeCompare(b.productName);
//       });
//     }

//     /**
//      * Add each parent product's most recently tested certificate to the results.
//      * The parent result is placed right after the last direct match of that
//      * parent, unless it is already among the results. Every entry is marked
//      * with whether it is its parent's most recent certificate.
//      * @param {Array<Object>} results - Sorted direct matches
//      * @returns {Array<{cert: Object, isLatestForParent: boolean}>} Result entries
//      */
//     addLatestParentResults(results) {
//       const lastIndexByParent = new Map();
//       results.forEach((cert, index) => lastIndexByParent.set(cert.parentKey, index));

//       const included = new Set(results);
//       const entries = [];

//       results.forEach((cert, index) => {
//         const latest = this.latestByParent.get(cert.parentKey);
//         entries.push({ cert, isLatestForParent: latest === cert });

//         const isLastMatchOfParent = lastIndexByParent.get(cert.parentKey) === index;
//         if (isLastMatchOfParent && latest && !included.has(latest)) {
//           entries.push({ cert: latest, isLatestForParent: true });
//           included.add(latest);
//         }
//       });

//       return entries;
//     }

//     /**
//      * Show loading state
//      */
//     showLoading() {
//       const template = document.getElementById('search-loading-template');
//       if (template) {
//         const clone = template.content.cloneNode(true);
//         this.searchResults.appendChild(clone);
//       }
//       this.showResults();
//     }

//     /**
//      * Clear search results container
//      */
//     clearSearchResults() {
//       if (this.searchResults) {
//         this.searchResults.innerHTML = '';
//       }
//     }

//     /**
//      * Render search results with product data
//      * @param {Array} results - Search result entries
//      */
//     renderSearchResults(results) {
//       const resultTemplate = this.getTemplate('search-result-item-template');
//       const dividerTemplate = this.getTemplate('search-result-divider-template');

//       if (!resultTemplate) return;

//       results.forEach((entry, index) => {
//         this.renderSingleResult(entry, resultTemplate);
//         this.addDividerIfNeeded(index, results.length, dividerTemplate);
//       });

//       this.setupResultClickListeners();
//     }

//     /**
//      * Get template by ID
//      * @param {string} templateId - Template ID
//      * @returns {HTMLTemplateElement|null} Template element
//      */
//     getTemplate(templateId) {
//       const template = document.getElementById(templateId);
//       if (!template) {
//         console.error(`Template not found: ${templateId}`);
//       }
//       return template;
//     }

//     /**
//      * Render a single search result
//      * @param {{cert: Object, isLatestForParent: boolean}} entry - Result entry
//      * @param {HTMLTemplateElement} template - Result template
//      */
//     renderSingleResult(entry, template) {
//       const { cert, isLatestForParent } = entry;
//       const productData = this.productService.getProductByHandle(cert.productHandle);
//       const clone = template.content.cloneNode(true);

//       this.populateResultData(clone, cert, productData);
//       this.setResultTitle(clone, cert, productData);
//       this.setResultImage(clone, cert, productData);
//       this.setResultDetails(clone, cert);
//       this.setLatestBadge(clone, isLatestForParent);

//       this.searchResults.appendChild(clone);
//     }

//     /**
//      * Show or hide the "Most recently tested" badge on a result
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {boolean} isLatest - Whether the result is its parent's most recent certificate
//      */
//     setLatestBadge(clone, isLatest) {
//       const resultEl = clone.querySelector('.sb-third-party-testing__search-result');
//       if (resultEl) {
//         resultEl.classList.toggle('sb-third-party-testing__search-result--latest', isLatest);
//       }

//       const badgeEl = clone.querySelector('[data-latest-badge]');
//       if (badgeEl) {
//         badgeEl.hidden = !isLatest;
//       }
//     }

//     /**
//      * Populate result data attributes
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} cert - Certificate data
//      * @param {Object} productData - Product data
//      */
//     populateResultData(clone, cert, productData) {
//       const resultEl = clone.querySelector('.sb-third-party-testing__search-result');

//       resultEl.dataset.productHandle = cert.productHandle;
//       resultEl.dataset.productTitle = cert.productName;
//       resultEl.dataset.lotNumber = cert.lotNumber;
//       resultEl.dataset.pdfUrl = cert.pdfurl;
//       resultEl.dataset.analysisType = cert.AnalysisType;
//       resultEl.dataset.testDate = getDisplayDate(cert);
//       resultEl.dataset.productData = productData ? JSON.stringify(productData) : '';
//     }

//     /**
//      * Set result title
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} cert - Certificate data
//      * @param {Object} productData - Product data
//      */
//     setResultTitle(clone, cert, productData) {
//       const titleEl = clone.querySelector('[data-title]');
//       if (titleEl) {
//         const displayTitle = cert?.productName || productData?.title || 'Product';
//         titleEl.textContent = displayTitle;
//       }
//     }

//     /**
//      * Set result image
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} cert - Certificate data
//      * @param {Object} productData - Product data
//      */
//     setResultImage(clone, cert, productData) {
//       const imageContainer = clone.querySelector('[data-image-container]');
//       if (imageContainer && productData?.featured_image) {
//         const displayTitle = productData?.title || cert.productName;
//         const img = this.createProductImage(
//           productData.featured_image ||
//             '//cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081',
//           displayTitle
//         );
//         imageContainer.replaceWith(img);
//       }
//     }

//     /**
//      * Create product image element
//      * @param {string} imageSrc - Image source URL
//      * @param {string} altText - Alt text
//      * @returns {HTMLImageElement} Image element
//      */
//     createProductImage(imageSrc, altText) {
//       const img = document.createElement('img');
//       img.src = imageSrc;
//       img.alt = altText;
//       img.className = 'sb-third-party-testing__search-result-image';
//       img.loading = 'lazy';
//       return img;
//     }

//     /**
//      * Add divider between results if needed
//      * @param {number} index - Current index
//      * @param {number} totalLength - Total results length
//      * @param {HTMLTemplateElement} dividerTemplate - Divider template
//      */
//     addDividerIfNeeded(index, totalLength, dividerTemplate) {
//       if (index < totalLength - 1 && dividerTemplate) {
//         const dividerClone = dividerTemplate.content.cloneNode(true);
//         this.searchResults.appendChild(dividerClone);
//       }
//     }

//     /**
//      * Render no results message
//      * @param {string} message - Optional custom message
//      */
//     renderNoResults(message = 'No results found for your search.') {
//       const template = this.getTemplate('search-no-results-template');
//       if (template) {
//         const clone = template.content.cloneNode(true);
//         this.setNoResultsMessage(clone, message);
//         this.searchResults.appendChild(clone);
//       }
//     }

//     /**
//      * Set no results message text
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {string} message - Message text
//      */
//     setNoResultsMessage(clone, message) {
//       const messageEl = clone.querySelector('[data-message]');
//       if (messageEl) {
//         messageEl.textContent = message;
//       }
//     }

//     /**
//      * Setup click listeners for search results
//      */
//     setupResultClickListeners() {
//       const results = this.searchResults.querySelectorAll('.sb-third-party-testing__search-result');
//       results.forEach((result) => {
//         result.addEventListener('click', (e) => {
//           const certificateData = this.extractCertificateData(e.currentTarget);
//           this.handleCertificateSelection(certificateData);
//         });
//       });
//     }

//     /**
//      * Extract certificate data from DOM element
//      * @param {HTMLElement} element - DOM element with data attributes
//      * @returns {Object} Certificate data object
//      */
//     extractCertificateData(element) {
//       return {
//         handle: element.dataset.productHandle,
//         title: element.dataset.productTitle,
//         lotNumber: element.dataset.lotNumber,
//         pdfUrl: element.dataset.pdfUrl,
//         analysisType: element.dataset.analysisType,
//         testDate: element.dataset.testDate,
//       };
//     }

//     /**
//      * Handle selection of a certificate from search results
//      * @param {Object} certificate - Certificate data object
//      */
//     handleCertificateSelection(certificate) {
//       this.storeCertificateData(certificate);
//       this.addToSearchHistory(certificate);
//       this.displayRecentProduct(certificate);
//       this.openCertificateInModal(certificate.pdfUrl);
//       this.clearSearchState();
//     }

//     /**
//      * Store certificate data in localStorage
//      * @param {Object} certificate - Certificate data object
//      */
//     storeCertificateData(certificate) {
//       localStorage.setItem('td_recent_product', JSON.stringify(certificate));
//     }

//     /**
//      * Open certificate PDF in modal using PDF.js
//      * @param {string} pdfUrl - PDF URL
//      */
//     openCertificateInModal(pdfUrl) {
//       if (!this.modalId) {
//         // Fallback to opening in new tab if no modal is available
//         window.open(pdfUrl, '_blank');
//         return;
//       }

//       // Get the PDF viewer template
//       const pdfTemplate = document.getElementById('sb-pdf-viewer-template');
//       if (!pdfTemplate) {
//         console.error('PDF viewer template not found');
//         window.open(pdfUrl, '_blank');
//         return;
//       }

//       // Convert the template clone to HTML string
//       const tempContainer = document.createElement('div');
//       const clone = pdfTemplate.content.cloneNode(true);
//       tempContainer.appendChild(clone);

//       // Dispatch event to update modal with the viewer HTML
//       document.dispatchEvent(
//         new CustomEvent('sb-modal:update', {
//           detail: {
//             modalId: this.modalId,
//             heading: 'Certificate of Analysis',
//             children: tempContainer.innerHTML,
//           },
//         })
//       );

//       // Open the modal
//       document.dispatchEvent(
//         new CustomEvent('sb-modal:open', {
//           detail: {
//             modalId: this.modalId,
//           },
//         })
//       );

//       // Initialize PDF.js once the modal is opened and elements are in the DOM
//       this.initPdfViewer(pdfUrl);
//     }

//     /**
//      * Initialize PDF.js viewer with optimized high-resolution rendering
//      * @param {string} pdfUrl - PDF URL
//      */
//     async initPdfViewer(pdfUrl) {
//       // Check if PDF.js is available
//       if (!window.pdfjsLib) {
//         console.error('PDF.js library not found');
//         window.open(pdfUrl, '_blank');
//         // Show close button so user can close the modal
//         this.showCloseButton();
//         return;
//       }

//       // Wait a bit for the modal to be fully in the DOM
//       setTimeout(async () => {
//         const container = document.querySelector('.sb-modal__body .sb-pdf-viewer__container');

//         if (!container) {
//           console.error('PDF container not found in modal');
//           // Show close button so user can close the modal
//           this.showCloseButton();
//           return;
//         }

//         try {
//           // Load the PDF document
//           const loadingTask = window.pdfjsLib.getDocument(pdfUrl);
//           const pdf = await loadingTask.promise;

//           // Get the first page
//           const page = await pdf.getPage(1);

//           // Remove loading indicator
//           const loadingElement = container.querySelector('.sb-pdf-viewer__loading');
//           if (loadingElement) loadingElement.remove();

//           // This page's own intrinsic size/orientation — pulled straight from
//           // its MediaBox, so it's already correct whether the source PDF is
//           // US Letter, A4, legal, or landscape. Nothing here needs to "detect"
//           // page size; it's inherent to viewport.
//           const containerWidth = container.clientWidth - 40; // Some margin
//           const viewport = page.getViewport({ scale: 1 });
//           const pageAspectRatio = viewport.height / viewport.width;
//           const devicePixelRatio = window.devicePixelRatio || 1;

//           // Detect screen size for optimized scaling
//           const isLargeScreen = window.innerWidth >= 1024; // Desktop/tablet landscape
//           const isHighDPI = devicePixelRatio > 1;

//           // Calculate base scale to fit container width
//           const baseScale = containerWidth / viewport.width;

//           // Enhanced scaling strategy for different screen sizes
//           let renderScale;
//           let maxScale;

//           if (isLargeScreen) {
//             // Large screens: prioritize quality, especially on high DPI displays
//             const minScale = isHighDPI ? 1.5 : 1.0; // Higher minimum for large screens
//             maxScale = isHighDPI ? 4.0 : 3.0; // Allow higher scaling on high DPI

//             // For large screens, use more aggressive scaling for quality
//             const qualityMultiplier = isHighDPI ? 2.0 : 1.5;
//             renderScale = Math.min(maxScale, Math.max(minScale, baseScale * devicePixelRatio * qualityMultiplier));
//           } else {
//             // Small screens: balance quality and performance
//             const minScale = 0.8; // Minimum scale to maintain quality
//             maxScale = 2.5; // Conservative max for mobile performance

//             // Use standard scaling for mobile devices
//             renderScale = Math.min(maxScale, Math.max(minScale, baseScale * devicePixelRatio));
//           }

//           // Create viewport for rendering (high resolution)
//           const renderViewport = page.getViewport({ scale: renderScale });

//           // Display size derived from THIS page's own aspect ratio, capped to
//           // the available container width. Setting this as explicit inline px
//           // (rather than relying on height:auto) is what prevents the cutoff —
//           // it can't be overridden by a fixed-size CSS rule elsewhere that
//           // assumes a Letter-shaped box.
//           const displayWidth = Math.min(containerWidth, viewport.width * baseScale);
//           const displayHeight = displayWidth * pageAspectRatio;

//           // Create canvas with optimized resolution
//           const canvas = document.createElement('canvas');
//           canvas.className = 'sb-pdf-viewer__canvas';

//           // Set canvas size for high-DPI rendering
//           canvas.width = renderViewport.width;
//           canvas.height = renderViewport.height;

//           // Style the canvas for proper display — explicit px, not height:auto
//           canvas.style.width = `${displayWidth}px`;
//           canvas.style.height = `${displayHeight}px`;
//           canvas.style.maxWidth = '100%';
//           canvas.style.display = 'block';
//           canvas.style.marginLeft = 'auto';
//           canvas.style.marginRight = 'auto';

//           // For large screens with high DPI, apply additional sharpening
//           if (isLargeScreen && isHighDPI) {
//             canvas.style.imageRendering = 'crisp-edges';
//             canvas.style.imageRendering = '-webkit-crisp-edges';
//           }

//           // Add canvas to container
//           container.appendChild(canvas);

//           // Get context and configure for high-DPI
//           const ctx = canvas.getContext('2d');

//           // Enable high-quality rendering
//           ctx.imageSmoothingEnabled = true;
//           ctx.imageSmoothingQuality = 'high';

//           // Render PDF page at optimized resolution
//           const renderContext = {
//             canvasContext: ctx,
//             viewport: renderViewport,
//           };

//           await page.render(renderContext).promise;

//           // Show close button after PDF has loaded successfully
//           this.showCloseButton();
//         } catch (err) {
//           console.error('Error rendering PDF:', err);
//           container.innerHTML = `
//           <div style="padding: 20px; text-align: center;">
//             <p>Unable to load PDF. <a href="${pdfUrl}" target="_blank" rel="noopener noreferrer">Open PDF in new tab</a></p>
//           </div>
//         `;

//           // Show close button even if PDF loading fails
//           this.showCloseButton();
//         }
//       }, 300); // Give the modal time to open
//     }

//     /**
//      * Show the close button in the PDF viewer modal
//      */
//     showCloseButton() {
//       const closeButton = document.querySelector('.sb-pdf-viewer__close');
//       if (closeButton) {
//         closeButton.style.display = 'flex';
//       }
//     }

//     /**
//      * Clear search input and hide results
//      */
//     clearSearchState() {
//       this.hideResults();
//       // this.searchInput.value = '';
//     }

//     /**
//      * Add search to history
//      * @param {Object} certificate - Certificate data object
//      */
//     addToSearchHistory(certificate) {
//       let searchHistory = this.getSearchHistory();
//       const searchEntry = this.createSearchHistoryEntry(certificate);

//       console.log(certificate);
//       searchHistory = this.removeDuplicateHistoryEntries(searchHistory, certificate.pdfUrl);
//       searchHistory = this.addAndLimitHistory(searchHistory, searchEntry);

//       this.saveSearchHistory(searchHistory);
//       this.refreshSearchHistory();
//     }

//     /**
//      * Get search history from localStorage
//      * @returns {Array} Search history array
//      */
//     getSearchHistory() {
//       return JSON.parse(localStorage.getItem('td_search_history') || '[]');
//     }

//     /**
//      * Create search history entry
//      * @param {Object} certificate - Certificate data object
//      * @returns {Object} Search history entry
//      */
//     createSearchHistoryEntry(certificate) {
//       return {
//         date: new Date().toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }),
//         productName: certificate.title,
//         testType: certificate.analysisType,
//         handle: certificate.handle,
//         image: this.productService.getProductByHandle(certificate.handle)?.featured_image || '',
//         pdfUrl: certificate.pdfUrl,
//         timestamp: Date.now(),
//       };
//     }

//     /**
//      * Remove duplicate entries for the same product
//      * @param {Array} searchHistory - Current search history
//      * @param {string} pdfUrl - PDF URL to remove duplicates for
//      * @returns {Array} Filtered search history
//      */
//     removeDuplicateHistoryEntries(searchHistory, pdfUrl) {
//       return searchHistory.filter((item) => item.pdfUrl !== pdfUrl);
//     }

//     /**
//      * Add new entry and limit history size
//      * @param {Array} searchHistory - Current search history
//      * @param {Object} searchEntry - New search entry
//      * @returns {Array} Updated search history
//      */
//     addAndLimitHistory(searchHistory, searchEntry) {
//       searchHistory.unshift(searchEntry);
//       return searchHistory.slice(0, 10);
//     }

//     /**
//      * Save search history to localStorage
//      * @param {Array} searchHistory - Search history to save
//      */
//     saveSearchHistory(searchHistory) {
//       localStorage.setItem('td_search_history', JSON.stringify(searchHistory));
//     }

//     /**
//      * Load and display search history
//      */
//     loadSearchHistory() {
//       this.refreshSearchHistory();
//     }

//     /**
//      * Refresh and display the entire search history
//      * Replaces displaySearchHistory() to ensure full UI update
//      */
//     refreshSearchHistory() {
//       if (!this.searchHistoryList) return;

//       const searchHistory = this.getSearchHistory();
//       const searchHistorySection = document.querySelector('.sb-third-party-testing__search-history');

//       if (searchHistory.length === 0) {
//         this.hideSearchHistorySection(searchHistorySection);
//         return;
//       }

//       this.showSearchHistorySection(searchHistorySection);
//       this.renderSearchHistoryItems(searchHistory);
//     }

//     /**
//      * Display search history in the sidebar
//      * @deprecated Use refreshSearchHistory() instead
//      */
//     displaySearchHistory() {
//       this.refreshSearchHistory();
//     }

//     /**
//      * Hide search history section
//      * @param {HTMLElement} section - Search history section element
//      */
//     hideSearchHistorySection(section) {
//       if (section) {
//         section.style.display = 'none';
//       }
//     }

//     /**
//      * Show search history section
//      * @param {HTMLElement} section - Search history section element
//      */
//     showSearchHistorySection(section) {
//       if (section) {
//         section.style.display = 'flex';
//       }
//     }

//     /**
//      * Render search history items
//      * @param {Array} searchHistory - Search history array
//      */
//     renderSearchHistoryItems(searchHistory) {
//       const template = this.getTemplate('search-history-item-template');
//       if (!template) return;

//       this.searchHistoryList.innerHTML = '';

//       searchHistory.forEach((item) => {
//         const clone = template.content.cloneNode(true);
//         this.populateSearchHistoryItem(clone, item);
//         this.searchHistoryList.appendChild(clone);
//       });
//     }

//     /**
//      * Populate search history item data
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} item - History item data
//      */
//     populateSearchHistoryItem(clone, item) {
//       clone.querySelectorAll('[data-date]').forEach((el) => (el.textContent = item.date));
//       clone.querySelectorAll('[data-product-name]').forEach((el) => (el.textContent = item.productName));
//       clone.querySelectorAll('[data-test-type]').forEach((el) => (el.textContent = item.testType));

//       const imgMount = clone.querySelector('[data-history-image]');
//       if (imgMount) {
//         let imageSrc = item.image || '';
//         if (!imageSrc && item.handle) {
//           const productData = this.productService.getProductByHandle(item.handle);
//           imageSrc = productData?.featured_image || '';
//         }

//         if (imageSrc) {
//           const img = document.createElement('img');
//           img.className = 'sb-third-party-testing__search-history-thumb-img sb-only-desktop';
//           img.alt = item.productName || 'Product image';
//           img.loading = 'lazy';
//           img.src = imageSrc;
//           imgMount.replaceWith(img);
//         } else {
//           // Keep mount as a subtle placeholder block
//           imgMount.classList.add('sb-third-party-testing__search-history-thumb-img');
//           imgMount.style.backgroundColor = '#f0f2f5';
//         }
//       }

//       const linkEl = clone.querySelector('[data-pdf-link]');
//       linkEl.href = 'javascript:void(0);'; // Prevent default navigation
//       linkEl.removeAttribute('target');

//       // Add click event to open in modal instead
//       linkEl.addEventListener('click', (e) => {
//         e.preventDefault();
//         this.openCertificateInModal(item.pdfUrl);
//       });
//     }

//     /**
//      * Display recent product in the main section
//      * @param {Object} certificate - Certificate data object
//      */
//     displayRecentProduct(certificate) {
//       if (!this.recentProductContainer || !this.recentProductContent) return;

//       const template = this.getTemplate('recent-product-template');
//       if (!template) return;

//       if (this.recentTitle) {
//         this.recentTitle.classList.remove('sb-third-party-testing__recent-title--hidden');
//       }

//       const clone = template.content.cloneNode(true);
//       const productData = this.productService.getProductByHandle(certificate.handle);
//       console.log('Displaying recent product:', certificate, productData);
//       this.setRecentProductImage(clone, certificate, productData);
//       this.setRecentProductTitle(clone, certificate, productData);
//       this.setRecentProductDescription(clone, certificate, productData);
//       this.setRecentProductLink(clone, certificate);
//       this.displayRecentProductContent(clone);
//     }

//     /**
//      * Set recent product image
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} certificate - Certificate data
//      * @param {Object} productData - Product data
//      */
//     setRecentProductImage(clone, certificate, productData) {
//       const imageEl = clone.querySelector('[data-image]');
//       if (productData?.featured_image) {
//         const img = document.createElement('img');
//         img.src = productData.featured_image;
//         img.alt = certificate.title;
//         img.className = 'sb-third-party-testing__recent-image';
//         img.loading = 'lazy';
//         imageEl.replaceWith(img);
//       } else {
//         imageEl.style.backgroundColor = '#f8f9fb';
//       }
//     }

//     /**
//      * Set recent product title
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} certificate - Certificate data
//      * @param {Object} productData - Product data
//      */
//     setRecentProductTitle(clone, certificate, productData) {
//       const displayTitle = productData?.title || certificate.title;
//       clone.querySelector('[data-title]').textContent = displayTitle;
//     }

//     /**
//      * Set recent product description
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} certificate - Certificate data
//      * @param {Object} productData - Product data
//      */
//     setRecentProductDescription(clone, certificate, productData) {
//       const description = this.getProductDescription(certificate, productData);
//       const cleanLimitedText = this.cleanAndLimitText(description, 18);
//       clone.querySelector('[data-description]').textContent = cleanLimitedText;
//     }

//     /**
//      * Get product description from various sources
//      * @param {Object} certificate - Certificate data
//      * @param {Object} productData - Product data
//      * @returns {string} Description text
//      */
//     getProductDescription(certificate, productData) {
//       if (productData?.description) {
//         if (productData.metafields?.plp_product_short_description) {
//           return productData.metafields.plp_product_short_description;
//         }
//         return productData.description;
//       }
//       return `Lot Number: ${certificate.lotNumber} | Test Type: ${certificate.analysisType} | Date: ${certificate.testDate}`;
//     }

//     /**
//      * Clean HTML and limit text to specified word count
//      * @param {string} text - Text to clean and limit
//      * @param {number} wordLimit - Maximum number of words
//      * @returns {string} Clean, limited text
//      */
//     cleanAndLimitText(text, wordLimit) {
//       const tempDiv = document.createElement('div');
//       tempDiv.innerHTML = text;
//       const cleanText = tempDiv.textContent || tempDiv.innerText || '';
//       return cleanText.split(' ').slice(0, wordLimit).join(' ');
//     }

//     /**
//      * Set recent product link
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} certificate - Certificate data
//      */
//     setRecentProductLink(clone, certificate) {
//       const productUrl = `/products/${certificate.handle}`;

//       // Set href on the content wrapper link
//       const contentLinkEl = clone.querySelector('[data-content-link]');
//       if (contentLinkEl) {
//         contentLinkEl.href = productUrl;
//       }
//     }

//     /**
//      * Display recent product content
//      * @param {DocumentFragment} clone - Cloned template content
//      */
//     displayRecentProductContent(clone) {
//       this.recentProductContent.innerHTML = '';
//       this.recentProductContent.appendChild(clone);
//       this.recentProductContainer.classList.add('sb-third-party-testing__recent-product--visible');
//     }

//     /**
//      * Load and display the most recent product
//      */
//     loadRecentProduct() {
//       const recentProduct = localStorage.getItem('td_recent_product');
//       if (recentProduct) {
//         try {
//           const productData = JSON.parse(recentProduct);
//           this.displayRecentProduct(productData);
//         } catch (error) {
//           console.error('Error loading recent product:', error);
//         }
//       }
//     }

//     /**
//      * Show search results dropdown
//      */
//     showResults() {
//       if (this.searchResults) {
//         this.searchResults.classList.add('sb-third-party-testing__search-results--visible');
//       }
//     }

//     /**
//      * Hide search results dropdown
//      */
//     hideResults() {
//       if (this.searchResults) {
//         this.searchResults.classList.remove('sb-third-party-testing__search-results--visible');
//       }
//     }

//     /**
//      * Set result details (test type and date)
//      * @param {DocumentFragment} clone - Cloned template
//      * @param {Object} cert - Certificate data
//      */
//     setResultDetails(clone, cert) {
//       const typeEl = clone.querySelector('[data-analysis-display-child]');
//       const dateEl = clone.querySelector('[data-test-date-child]');

//       // Set test type - try both camelCase and PascalCase property names
//       if (typeEl) {
//         const analysisType = cert.analysisType || cert.AnalysisType;
//         typeEl.textContent = analysisType || 'Test';
//       }

//       // Set date (parsed manually, so it displays correctly in every browser)
//       if (dateEl && cert.date) {
//         dateEl.textContent = getDisplayDate(cert);
//       }
//     }
//   }

//   // Register the custom element
//   customElements.define('sb-product-search', TdProductSearch);
// }



/**
 * TdProductSearch Web Component
 * Handles product search for third-party testing certificates using local JSON data
 *
 * Besides the direct matches, search results include the most recent
 * certificate of each configured analysis type (COA and Ingredient
 * Verification, plus Gluten for whey protein isolate) for every parent product
 * that appears in the results. Searching "Sour Grape" shows
 * Creatine HMB - Sour Grape plus the newest Creatine HMB COA and the newest
 * Creatine HMB Ingredient Verification, whichever flavors those currently are.
 *
 * Search also matches the analysis type, so "Amino" finds amino acid profiles.
 * The most recent Amino Acid Profile is also added for every product that has
 * one, so any whey flavor search shows the newest amino test of any flavor.
 *
 * The certificate modal renders every page of the PDF, stacked vertically.
 *
 * @class TdProductSearch
 * @extends HTMLElement
 */

// Everything lives inside this guard so that loading the script twice
// does not throw "Identifier has already been declared".
if (!customElements.get('sb-product-search')) {
  /* ---------------------------------------------------------------------------
   * Configuration
   * ------------------------------------------------------------------------- */

  /** Minimum number of characters before a search runs */
  const MIN_QUERY_LENGTH = 2;

  /** Maximum number of direct matches shown (parent "latest" results are added on top) */
  const MAX_RESULTS = 12;

  /** Vertical gap between rendered PDF pages in the modal, in px */
  const PDF_PAGE_GAP = 16;

  /**
   * Analysis types whose most recent certificate is shown for every parent
   * product in the results, in the order they are listed. Values are the
   * normalized keys from ANALYSIS_TYPE_ALIASES.
   */
  const LATEST_ANALYSIS_TYPES = ['coa', 'ingredient-verification', 'amino-acid-profile'];

  /**
   * Additional analysis types to show for specific parent products (by parent key).
   */
  const EXTRA_LATEST_ANALYSIS_TYPES = {
    'whey-protein-isolate': ['gluten'],
  };

  /**
   * The certificate data spells analysis types in several ways.
   * These map each spelling (lowercase) to one normalized key.
   */
  const ANALYSIS_TYPE_ALIASES = {
    coa: 'coa',
    'ingredient verification': 'ingredient-verification',
    'inggredient verification': 'ingredient-verification',
    'ingredient composition': 'ingredient-verification',
    gluten: 'gluten',
    'gluten test': 'gluten',
    'amino acid profile': 'amino-acid-profile',
    'amino acids profile': 'amino-acid-profile',
    'amino acid': 'amino-acid-profile',
  };

  /** Display label for each normalized analysis type */
  const ANALYSIS_TYPE_LABELS = {
    coa: 'COA',
    'ingredient-verification': 'Ingredient Verification',
    gluten: 'Gluten',
    'amino-acid-profile': 'Amino Acid Profile',
  };

  /**
   * Some records in the certificate data use inconsistent product handles.
   * These aliases group them under one parent product. They are only used for
   * grouping; links still use each record's own handle.
   */
  const PARENT_HANDLE_ALIASES = {
    '-bcaa-powder': 'bcaa-powder',
    '-post-workout': 'post-workout',
    '-workout': 'intra-workout',
    'lean-preworkout': 'lean-pre-workout',
  };

  /* ---------------------------------------------------------------------------
   * Certificate data helpers
   * ------------------------------------------------------------------------- */

  /**
   * Parse a certificate date in MM-DD-YYYY format.
   * new Date('05-29-2026') is not reliable across browsers (Safari rejects it),
   * so the parts are read manually. Returns a timestamp, or null if invalid.
   * @param {string} value - Date string from the certificate data
   * @returns {number|null} Timestamp or null
   */
  function parseCertificateDate(value) {
    // The day allows up to 3 digits to tolerate zero-padded typos like "05-013-2025"
    const match = String(value || '')
      .trim()
      .match(/^(\d{1,2})-(\d{1,3})-(\d{4})$/);
    if (!match) return null;

    const month = Number(match[1]);
    const day = Number(match[2]);
    const year = Number(match[3]);
    const date = new Date(year, month - 1, day);

    const isRealDate = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
    return isRealDate ? date.getTime() : null;
  }

  /**
   * Format a timestamp as M/D/YYYY
   * @param {number} timestamp - Timestamp
   * @returns {string} Formatted date
   */
  function formatCertificateDate(timestamp) {
    const date = new Date(timestamp);
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  }

  /**
   * Display text for a certificate's date
   * @param {Object} cert - Prepared certificate
   * @returns {string} Display date
   */
  function getDisplayDate(cert) {
    return cert.timestamp !== null ? formatCertificateDate(cert.timestamp) : cert.date;
  }

  /**
   * Get the parent product key used to group flavors together
   * @param {string} handle - Product handle from the certificate data
   * @returns {string} Parent key
   */
  function getParentKey(handle) {
    const key = String(handle || '')
      .trim()
      .toLowerCase();
    return PARENT_HANDLE_ALIASES[key] || key;
  }

  /**
   * Normalize an analysis type so different spellings are treated as one type
   * @param {string} analysisType - Analysis type from the certificate data
   * @returns {string} Normalized key (e.g. 'coa', 'ingredient-verification', 'gluten')
   */
  function getAnalysisTypeKey(analysisType) {
    const key = String(analysisType || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
    return ANALYSIS_TYPE_ALIASES[key] || key;
  }

  /**
   * Display label for a certificate's analysis type
   * @param {Object} cert - Prepared certificate
   * @returns {string} Label
   */
  function getAnalysisTypeLabel(cert) {
    return ANALYSIS_TYPE_LABELS[cert.analysisTypeKey] || cert.AnalysisType || 'Test';
  }

  /**
   * Analysis types whose most recent certificate is shown for a parent product
   * @param {string} parentKey - Parent key
   * @returns {Array<string>} Normalized analysis type keys, in display order
   */
  function getLatestTypesForParent(parentKey) {
    // Normalized, so 'Gluten' or 'Gluten Test' in the config still works
    const types = [...LATEST_ANALYSIS_TYPES, ...(EXTRA_LATEST_ANALYSIS_TYPES[parentKey] || [])].map(getAnalysisTypeKey);
    return [...new Set(types)];
  }

  /**
   * Split a lot number into [YYMMDD, sequence] for tie-breaking.
   * Lot numbers vary in length (e.g. 26051332 vs 260415114), so comparing
   * them as whole numbers would be wrong.
   * @param {string} lotNumber - Lot number
   * @returns {Array<number>} Sort key
   */
  function getLotSortKey(lotNumber) {
    const digits = String(lotNumber || '').replace(/\D/g, '');
    return [Number(digits.slice(0, 6)) || 0, Number(digits.slice(6)) || 0];
  }

  /**
   * Whether certificate a is more recent than certificate b.
   * Compares test dates first; on the same date, the later lot wins.
   * @param {Object} a - Prepared certificate
   * @param {Object} b - Prepared certificate
   * @returns {boolean} True if a is newer
   */
  function isNewerCertificate(a, b) {
    if (a.timestamp !== b.timestamp) return a.timestamp > b.timestamp;

    const [aDate, aSequence] = getLotSortKey(a.lotNumber);
    const [bDate, bSequence] = getLotSortKey(b.lotNumber);
    if (aDate !== bDate) return aDate > bDate;
    return aSequence > bSequence;
  }

  /**
   * Clean up raw certificate records: trim fields, drop exact duplicates,
   * and precompute the values used for searching and grouping.
   * @param {Array<Object>} rawRecords - Records parsed from window.coajd
   * @returns {Array<Object>} Prepared certificates
   */
  function prepareCertificates(rawRecords) {
    const seen = new Set();
    const prepared = [];

    rawRecords.forEach((raw) => {
      if (!raw || typeof raw !== 'object') return;

      const cert = {
        ...raw,
        productName: String(raw.productName || '').trim(),
        productHandle: String(raw.productHandle || '').trim(),
        lotNumber: String(raw.lotNumber || '').trim(),
        AnalysisType: String(raw.AnalysisType || '').trim(),
        pdfurl: String(raw.pdfurl || '').trim(),
        date: String(raw.date || '').trim(),
      };

      const duplicateKey = [cert.productName, cert.lotNumber, cert.AnalysisType, cert.pdfurl].join('|');
      if (seen.has(duplicateKey)) return;
      seen.add(duplicateKey);

      cert.parentKey = getParentKey(cert.productHandle);
      cert.analysisTypeKey = getAnalysisTypeKey(cert.AnalysisType);
      cert.timestamp = parseCertificateDate(cert.date);

      // productName must stay first: relevance sorting uses searchFields[0].
      // The analysis type is included so searches like "Amino" find amino acid profiles.
      cert.searchFields = [
        cert.productName,
        cert.productHandle,
        cert.lotNumber,
        cert.AnalysisType,
        getAnalysisTypeLabel(cert),
      ].map((field) => field.toLowerCase());

      prepared.push(cert);
    });

    return prepared;
  }

  /**
   * Find the most recent certificate of each analysis type for each parent product
   * @param {Array<Object>} certificates - Prepared certificates
   * @returns {Map<string, Map<string, Object>>} Parent key -> analysis type key -> most recent certificate
   */
  function buildLatestByParent(certificates) {
    const latestByParent = new Map();

    certificates.forEach((cert) => {
      // Records without a usable date can't be ranked
      if (!cert.parentKey || !cert.analysisTypeKey || cert.timestamp === null) return;

      if (!latestByParent.has(cert.parentKey)) {
        latestByParent.set(cert.parentKey, new Map());
      }

      const latestByType = latestByParent.get(cert.parentKey);
      const current = latestByType.get(cert.analysisTypeKey);
      if (!current || isNewerCertificate(cert, current)) {
        latestByType.set(cert.analysisTypeKey, cert);
      }
    });

    return latestByParent;
  }

  /**
   * The most recent certificates to show for a parent product, one per
   * configured analysis type, in display order. Types with no certificate are skipped.
   * @param {Map<string, Map<string, Object>>} latestByParent - Result of buildLatestByParent
   * @param {string} parentKey - Parent key
   * @returns {Array<Object>} Certificates
   */
  function getLatestCertificatesForParent(latestByParent, parentKey) {
    const latestByType = latestByParent.get(parentKey);
    if (!latestByType) return [];

    return getLatestTypesForParent(parentKey)
      .map((typeKey) => latestByType.get(typeKey))
      .filter(Boolean);
  }

  /**
   * Simple service class for accessing pre-rendered product data
   */
  class ProductDataService {
    constructor() {
      this.productData = {};
      this.isDataLoaded = false;
      this.waitForProductData();
    }

    /**
     * Wait for product data to be available
     */
    waitForProductData() {
      if (window.tdProductData) {
        this.productData = window.tdProductData;
        this.isDataLoaded = true;
      } else {
        console.error('Product data not found. Make sure sb-product-data-map.js.liquid is loaded.');
      }
    }

    /**
     * Get product data by handle (synchronous)
     * @param {string} handle - Product handle
     * @returns {Object|null} Product data or null if not found
     */
    getProductByHandle(handle) {
      if (!this.isDataLoaded) {
        console.warn('Product data not yet loaded');
        return null;
      }

      return this.productData[handle] || null;
    }

    /**
     * Get multiple products by handles (synchronous)
     * @param {Array<string>} handles - Array of product handles
     * @returns {Array<Object>} Array of product data
     */
    getProductsBatch(handles) {
      return handles.map((handle) => this.getProductByHandle(handle)).filter(Boolean);
    }

    /**
     * Check if product data is loaded
     * @returns {boolean} True if data is loaded
     */
    isLoaded() {
      return this.isDataLoaded;
    }
  }

  class TdProductSearch extends HTMLElement {
    constructor() {
      super();
      this.searchInput = null;
      this.searchResults = null;
      this.searchButton = null;
      this.searchTimeout = null;
      this.recentProductContainer = null;
      this.recentProductContent = null;
      this.searchHistoryList = null;
      this.recentSection = null;
      this.searchHistorySection = null;
      this.certificateData = [];
      this.latestByParent = new Map();
      this.isDataLoaded = false;
      this.productService = new ProductDataService();
      this.modalId = null;
      // Incremented each time a PDF is opened, so a slow earlier render stops
      // instead of drawing its pages into a newer certificate's modal
      this.pdfRenderId = 0;
    }

    connectedCallback() {
      this.initializeElements();
      this.waitForCertificateData();
      this.setupEventListeners();
      this.initializeDataDependentSections();
      this.modalId = this.getAttribute('data-modal-id');
    }

    /**
     * Initialize sections that depend on data being loaded
     */
    initializeDataDependentSections() {
      // Only load and show sections if both product and certificate data are available
      if (this.productService.isLoaded() && this.isDataLoaded) {
        this.loadRecentProduct();
        this.loadSearchHistory();
        this.showDataDependentSections();
      } else {
        // Wait a bit and try again
        setTimeout(() => this.initializeDataDependentSections(), 100);
      }
    }

    /**
     * Show the sections that depend on data being loaded
     */
    showDataDependentSections() {
      if (this.recentSection) {
        this.recentSection.classList.add('sb-third-party-testing__recent-section--visible');
      }
      if (this.searchHistorySection) {
        this.searchHistorySection.classList.add('sb-third-party-testing__search-history--visible');
      }
    }

    /**
     * Initialize DOM element references
     */
    initializeElements() {
      this.searchInput = this.querySelector('[data-search-input]');
      this.searchResults = this.querySelector('[data-search-results]');
      this.searchButton = this.querySelector('[data-search-button]');
      this.recentTitle = document.querySelector('[data-recent-title]');
      this.recentProductContainer = document.querySelector('[data-recent-product]');
      this.recentProductContent = document.querySelector('[data-recent-content]');
      this.searchHistoryList = document.querySelector('[data-search-history-list]');
      this.recentSection = document.querySelector('[data-recent-section]');
      this.searchHistorySection = document.querySelector('[data-search-history-section]');
    }

    /**
     * Wait for certificate data to be available and then load it
     */
    waitForCertificateData() {
      if (window.coajd) {
        this.loadCertificateData();
      } else {
        console.error('Certificate data not found. Make sure certificate-of-analysis-json-data.js.liquid is loaded.');
      }
    }

    /**
     * Load and parse certificate data from global variable
     */
    loadCertificateData() {
      try {
        if (window.coajd) {
          const parsed = JSON.parse(window.coajd);
          this.certificateData = prepareCertificates(Array.isArray(parsed) ? parsed : []);
          this.latestByParent = buildLatestByParent(this.certificateData);
          this.isDataLoaded = true;
        } else {
          console.error('Certificate data not found. Make sure certificate-of-analysis-json-data.js.liquid is loaded.');
        }
      } catch (error) {
        console.error('Error parsing certificate data:', error);
      }
    }

    /**
     * Setup all event listeners
     */
    setupEventListeners() {
      if (!this.searchInput) return;

      this.setupInputEventListeners();
      this.setupSearchButtonListener();
    }

    /**
     * Setup input field event listeners
     */
    setupInputEventListeners() {
      // Debounced input search
      this.searchInput.addEventListener('input', (e) => {
        this.handleInputChange(e.target.value.trim());
      });

      // Hide results when clicking outside
      this.searchInput.addEventListener('blur', () => {
        setTimeout(() => this.hideResults(), 200);
      });

      // Show results when focusing if there are results
      this.searchInput.addEventListener('focus', () => {
        this.handleInputFocus();
      });

      // Handle enter key press
      this.searchInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.handleSearch();
        }
      });
    }

    /**
     * Setup search button event listener
     */
    setupSearchButtonListener() {
      if (this.searchButton) {
        this.searchButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleSearch();
        });
      }
    }

    /**
     * Handle input value changes with debouncing
     * @param {string} query - Search query
     */
    handleInputChange(query) {
      clearTimeout(this.searchTimeout);
      this.hideResults();

      // Too short to search: clear old results so focusing the input doesn't show them again
      if (query.length < MIN_QUERY_LENGTH) {
        this.clearSearchResults();
        return;
      }

      this.searchTimeout = setTimeout(() => {
        this.performSearch(query);
      }, 300);
    }

    /**
     * Handle input focus events
     */
    handleInputFocus() {
      if (this.searchResults.children.length > 0) {
        this.showResults();
      }
    }

    /**
     * Handle search button click or enter key press
     */
    handleSearch() {
      const query = this.searchInput.value.trim();
      if (query.length >= MIN_QUERY_LENGTH) {
        clearTimeout(this.searchTimeout);
        this.performSearch(query);
      }
    }

    /**
     * Perform search using local certificate data
     * @param {string} query - Search query
     */
    performSearch(query) {
      if (!this.isDataLoaded) {
        this.clearSearchResults();
        this.renderNoResults('Certificate data is still loading...');
        return;
      }

      try {
        this.clearSearchResults();
        this.showLoading();
        const results = this.searchCertificates(query);

        setTimeout(() => {
          this.handleSearchResults(results);
        }, 100);
      } catch (error) {
        console.error('Search error:', error);
        this.clearSearchResults();
        this.renderNoResults('An error occurred while searching.');
      }
    }

    /**
     * Handle search results display
     * @param {Array} results - Search result entries
     */
    handleSearchResults(results) {
      this.clearSearchResults();
      if (results.length > 0) {
        this.renderSearchResults(results);
      } else {
        this.renderNoResults();
      }
      this.showResults();
    }

    /**
     * Search through certificate data
     * @param {string} query - Search query
     * @returns {Array<{cert: Object, isLatestForParent: boolean}>} Result entries
     */
    searchCertificates(query) {
      const queryLower = query.trim().toLowerCase();
      if (queryLower.length < MIN_QUERY_LENGTH) return [];

      const matches = this.findMatchingCertificates(queryLower);
      const sorted = this.sortCertificatesByRelevance(matches, queryLower).slice(0, MAX_RESULTS);

      return this.addLatestParentResults(sorted);
    }

    /**
     * Find certificates matching the search query
     * @param {string} queryLower - Lowercase search query
     * @returns {Array} Matching certificates
     */
    findMatchingCertificates(queryLower) {
      return this.certificateData.filter((cert) => cert.searchFields.some((field) => field.includes(queryLower)));
    }

    /**
     * Sort certificates by relevance
     * @param {Array} matches - Matching certificates
     * @param {string} queryLower - Lowercase search query
     * @returns {Array} Sorted certificates
     */
    sortCertificatesByRelevance(matches, queryLower) {
      return matches.sort((a, b) => {
        const aExact = a.searchFields[0].startsWith(queryLower);
        const bExact = b.searchFields[0].startsWith(queryLower);

        if (aExact && !bExact) return -1;
        if (!aExact && bExact) return 1;

        // Secondary sort by date (newest first); records without a valid date go last
        const aTime = a.timestamp !== null ? a.timestamp : -Infinity;
        const bTime = b.timestamp !== null ? b.timestamp : -Infinity;
        if (aTime !== bTime) return bTime - aTime;

        // Same date: later lot first, matching how the most recent certificate is chosen
        if (isNewerCertificate(a, b)) return -1;
        if (isNewerCertificate(b, a)) return 1;

        return a.productName.localeCompare(b.productName);
      });
    }

    /**
     * Add each parent product's most recent certificates (one per configured
     * analysis type) to the results. They are placed right after the last direct
     * match of that parent, skipping any already among the results. Every entry
     * is marked with whether it is one of its parent's most recent certificates.
     * @param {Array<Object>} results - Sorted direct matches
     * @returns {Array<{cert: Object, isLatestForParent: boolean}>} Result entries
     */
    addLatestParentResults(results) {
      const lastIndexByParent = new Map();
      results.forEach((cert, index) => lastIndexByParent.set(cert.parentKey, index));

      const included = new Set(results);
      const entries = [];

      results.forEach((cert, index) => {
        const latestForParent = getLatestCertificatesForParent(this.latestByParent, cert.parentKey);
        entries.push({ cert, isLatestForParent: latestForParent.includes(cert) });

        const isLastMatchOfParent = lastIndexByParent.get(cert.parentKey) === index;
        if (!isLastMatchOfParent) return;

        latestForParent.forEach((latest) => {
          if (included.has(latest)) return;
          entries.push({ cert: latest, isLatestForParent: true });
          included.add(latest);
        });
      });

      return entries;
    }

    /**
     * Show loading state
     */
    showLoading() {
      const template = document.getElementById('search-loading-template');
      if (template) {
        const clone = template.content.cloneNode(true);
        this.searchResults.appendChild(clone);
      }
      this.showResults();
    }

    /**
     * Clear search results container
     */
    clearSearchResults() {
      if (this.searchResults) {
        this.searchResults.innerHTML = '';
      }
    }

    /**
     * Render search results with product data
     * @param {Array} results - Search result entries
     */
    renderSearchResults(results) {
      const resultTemplate = this.getTemplate('search-result-item-template');
      const dividerTemplate = this.getTemplate('search-result-divider-template');

      if (!resultTemplate) return;

      results.forEach((entry, index) => {
        this.renderSingleResult(entry, resultTemplate);
        this.addDividerIfNeeded(index, results.length, dividerTemplate);
      });

      this.setupResultClickListeners();
    }

    /**
     * Get template by ID
     * @param {string} templateId - Template ID
     * @returns {HTMLTemplateElement|null} Template element
     */
    getTemplate(templateId) {
      const template = document.getElementById(templateId);
      if (!template) {
        console.error(`Template not found: ${templateId}`);
      }
      return template;
    }

    /**
     * Render a single search result
     * @param {{cert: Object, isLatestForParent: boolean}} entry - Result entry
     * @param {HTMLTemplateElement} template - Result template
     */
    renderSingleResult(entry, template) {
      const { cert, isLatestForParent } = entry;
      const productData = this.productService.getProductByHandle(cert.productHandle);
      const clone = template.content.cloneNode(true);

      this.populateResultData(clone, cert, productData);
      this.setResultTitle(clone, cert, productData);
      this.setResultImage(clone, cert, productData);
      this.setResultDetails(clone, cert);
      this.setLatestBadge(clone, isLatestForParent);

      this.searchResults.appendChild(clone);
    }

    /**
     * Show or hide the "Most recently tested" badge on a result
     * @param {DocumentFragment} clone - Cloned template
     * @param {boolean} isLatest - Whether the result is its parent's most recent certificate
     */
    setLatestBadge(clone, isLatest) {
      const resultEl = clone.querySelector('.sb-third-party-testing__search-result');
      if (resultEl) {
        resultEl.classList.toggle('sb-third-party-testing__search-result--latest', isLatest);
      }

      const badgeEl = clone.querySelector('[data-latest-badge]');
      if (badgeEl) {
        badgeEl.hidden = !isLatest;
      }
    }

    /**
     * Populate result data attributes
     * @param {DocumentFragment} clone - Cloned template
     * @param {Object} cert - Certificate data
     * @param {Object} productData - Product data
     */
    populateResultData(clone, cert, productData) {
      const resultEl = clone.querySelector('.sb-third-party-testing__search-result');

      resultEl.dataset.productHandle = cert.productHandle;
      resultEl.dataset.productTitle = cert.productName;
      resultEl.dataset.lotNumber = cert.lotNumber;
      resultEl.dataset.pdfUrl = cert.pdfurl;
      resultEl.dataset.analysisType = getAnalysisTypeLabel(cert);
      resultEl.dataset.testDate = getDisplayDate(cert);
      resultEl.dataset.productData = productData ? JSON.stringify(productData) : '';
    }

    /**
     * Set result title
     * @param {DocumentFragment} clone - Cloned template
     * @param {Object} cert - Certificate data
     * @param {Object} productData - Product data
     */
    setResultTitle(clone, cert, productData) {
      const titleEl = clone.querySelector('[data-title]');
      if (titleEl) {
        const displayTitle = cert?.productName || productData?.title || 'Product';
        titleEl.textContent = displayTitle;
      }
    }

    /**
     * Set result image
     * @param {DocumentFragment} clone - Cloned template
     * @param {Object} cert - Certificate data
     * @param {Object} productData - Product data
     */
    setResultImage(clone, cert, productData) {
      const imageContainer = clone.querySelector('[data-image-container]');
      if (imageContainer && productData?.featured_image) {
        const displayTitle = productData?.title || cert.productName;
        const img = this.createProductImage(
          productData.featured_image ||
            '//cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?v=1530129081',
          displayTitle
        );
        imageContainer.replaceWith(img);
      }
    }

    /**
     * Create product image element
     * @param {string} imageSrc - Image source URL
     * @param {string} altText - Alt text
     * @returns {HTMLImageElement} Image element
     */
    createProductImage(imageSrc, altText) {
      const img = document.createElement('img');
      img.src = imageSrc;
      img.alt = altText;
      img.className = 'sb-third-party-testing__search-result-image';
      img.loading = 'lazy';
      return img;
    }

    /**
     * Add divider between results if needed
     * @param {number} index - Current index
     * @param {number} totalLength - Total results length
     * @param {HTMLTemplateElement} dividerTemplate - Divider template
     */
    addDividerIfNeeded(index, totalLength, dividerTemplate) {
      if (index < totalLength - 1 && dividerTemplate) {
        const dividerClone = dividerTemplate.content.cloneNode(true);
        this.searchResults.appendChild(dividerClone);
      }
    }

    /**
     * Render no results message
     * @param {string} message - Optional custom message
     */
    renderNoResults(message = 'No results found for your search.') {
      const template = this.getTemplate('search-no-results-template');
      if (template) {
        const clone = template.content.cloneNode(true);
        this.setNoResultsMessage(clone, message);
        this.searchResults.appendChild(clone);
      }
    }

    /**
     * Set no results message text
     * @param {DocumentFragment} clone - Cloned template
     * @param {string} message - Message text
     */
    setNoResultsMessage(clone, message) {
      const messageEl = clone.querySelector('[data-message]');
      if (messageEl) {
        messageEl.textContent = message;
      }
    }

    /**
     * Setup click listeners for search results
     */
    setupResultClickListeners() {
      const results = this.searchResults.querySelectorAll('.sb-third-party-testing__search-result');
      results.forEach((result) => {
        result.addEventListener('click', (e) => {
          const certificateData = this.extractCertificateData(e.currentTarget);
          this.handleCertificateSelection(certificateData);
        });
      });
    }

    /**
     * Extract certificate data from DOM element
     * @param {HTMLElement} element - DOM element with data attributes
     * @returns {Object} Certificate data object
     */
    extractCertificateData(element) {
      return {
        handle: element.dataset.productHandle,
        title: element.dataset.productTitle,
        lotNumber: element.dataset.lotNumber,
        pdfUrl: element.dataset.pdfUrl,
        analysisType: element.dataset.analysisType,
        testDate: element.dataset.testDate,
      };
    }

    /**
     * Handle selection of a certificate from search results
     * @param {Object} certificate - Certificate data object
     */
    handleCertificateSelection(certificate) {
      this.storeCertificateData(certificate);
      this.addToSearchHistory(certificate);
      this.displayRecentProduct(certificate);
      this.openCertificateInModal(certificate.pdfUrl);
      this.clearSearchState();
    }

    /**
     * Store certificate data in localStorage
     * @param {Object} certificate - Certificate data object
     */
    storeCertificateData(certificate) {
      localStorage.setItem('td_recent_product', JSON.stringify(certificate));
    }

    /**
     * Open certificate PDF in modal using PDF.js
     * @param {string} pdfUrl - PDF URL
     */
    openCertificateInModal(pdfUrl) {
      if (!this.modalId) {
        // Fallback to opening in new tab if no modal is available
        window.open(pdfUrl, '_blank');
        return;
      }

      // Get the PDF viewer template
      const pdfTemplate = document.getElementById('sb-pdf-viewer-template');
      if (!pdfTemplate) {
        console.error('PDF viewer template not found');
        window.open(pdfUrl, '_blank');
        return;
      }

      // Convert the template clone to HTML string
      const tempContainer = document.createElement('div');
      const clone = pdfTemplate.content.cloneNode(true);
      tempContainer.appendChild(clone);

      // Dispatch event to update modal with the viewer HTML
      document.dispatchEvent(
        new CustomEvent('sb-modal:update', {
          detail: {
            modalId: this.modalId,
            heading: 'Certificate of Analysis',
            children: tempContainer.innerHTML,
          },
        })
      );

      // Open the modal
      document.dispatchEvent(
        new CustomEvent('sb-modal:open', {
          detail: {
            modalId: this.modalId,
          },
        })
      );

      // Initialize PDF.js once the modal is opened and elements are in the DOM
      this.initPdfViewer(pdfUrl);
    }

    /**
     * Initialize PDF.js viewer and render every page of the PDF, stacked
     * vertically, at an optimized high resolution
     * @param {string} pdfUrl - PDF URL
     */
    async initPdfViewer(pdfUrl) {
      // Check if PDF.js is available
      if (!window.pdfjsLib) {
        console.error('PDF.js library not found');
        window.open(pdfUrl, '_blank');
        // Show close button so user can close the modal
        this.showCloseButton();
        return;
      }

      this.pdfRenderId += 1;
      const renderId = this.pdfRenderId;

      // Wait a bit for the modal to be fully in the DOM
      setTimeout(async () => {
        const container = document.querySelector('.sb-modal__body .sb-pdf-viewer__container');

        if (!container) {
          console.error('PDF container not found in modal');
          // Show close button so user can close the modal
          this.showCloseButton();
          return;
        }

        // Stop if another certificate was opened or the modal content was replaced
        const isStale = () => renderId !== this.pdfRenderId || !container.isConnected;

        try {
          // Load the PDF document (kept, so every page can be rendered)
          const pdf = await window.pdfjsLib.getDocument(pdfUrl).promise;
          if (isStale()) return;

          // Remove loading indicator
          const loadingElement = container.querySelector('.sb-pdf-viewer__loading');
          if (loadingElement) loadingElement.remove();

          // Measured once, so every page is laid out at the same width
          const containerWidth = container.clientWidth - 40; // Some margin

          for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
            const page = await pdf.getPage(pageNumber);
            if (isStale()) return;

            const { canvas, renderViewport } = this.createPdfPageCanvas(page, containerWidth);
            canvas.setAttribute('aria-label', `Page ${pageNumber} of ${pdf.numPages}`);
            if (pageNumber > 1) canvas.style.marginTop = `${PDF_PAGE_GAP}px`;
            container.appendChild(canvas);

            // Get context and configure for high-DPI
            const ctx = canvas.getContext('2d');
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';

            await page.render({ canvasContext: ctx, viewport: renderViewport }).promise;

            // Let the user close the modal as soon as the first page is visible
            if (pageNumber === 1) this.showCloseButton();
          }
        } catch (err) {
          if (isStale()) return;
          console.error('Error rendering PDF:', err);
          container.innerHTML = `
          <div style="padding: 20px; text-align: center;">
            <p>Unable to load PDF. <a href="${pdfUrl}" target="_blank" rel="noopener noreferrer">Open PDF in new tab</a></p>
          </div>
        `;

          // Show close button even if PDF loading fails
          this.showCloseButton();
        }
      }, 300); // Give the modal time to open
    }

    /**
     * Create a sized canvas for one PDF page
     * @param {Object} page - PDF.js page
     * @param {number} containerWidth - Available width in px
     * @returns {{canvas: HTMLCanvasElement, renderViewport: Object}} Canvas and the viewport to render with
     */
    createPdfPageCanvas(page, containerWidth) {
      // This page's own intrinsic size/orientation — pulled straight from
      // its MediaBox, so it's already correct whether the source PDF is
      // US Letter, A4, legal, or landscape, even if pages differ.
      const viewport = page.getViewport({ scale: 1 });
      const pageAspectRatio = viewport.height / viewport.width;
      const devicePixelRatio = window.devicePixelRatio || 1;

      // Detect screen size for optimized scaling
      const isLargeScreen = window.innerWidth >= 1024; // Desktop/tablet landscape
      const isHighDPI = devicePixelRatio > 1;

      // Calculate base scale to fit container width
      const baseScale = containerWidth / viewport.width;

      let renderScale;
      if (isLargeScreen) {
        // Large screens: prioritize quality, especially on high DPI displays
        const minScale = isHighDPI ? 1.5 : 1.0;
        const maxScale = isHighDPI ? 4.0 : 3.0;
        const qualityMultiplier = isHighDPI ? 2.0 : 1.5;
        renderScale = Math.min(maxScale, Math.max(minScale, baseScale * devicePixelRatio * qualityMultiplier));
      } else {
        // Small screens: balance quality and performance
        const minScale = 0.8;
        const maxScale = 2.5;
        renderScale = Math.min(maxScale, Math.max(minScale, baseScale * devicePixelRatio));
      }

      // Create viewport for rendering (high resolution)
      const renderViewport = page.getViewport({ scale: renderScale });

      // Display size derived from THIS page's own aspect ratio, capped to
      // the available container width. Explicit inline px (rather than
      // height:auto) can't be overridden by a fixed-size CSS rule elsewhere
      // that assumes a Letter-shaped box.
      const displayWidth = Math.min(containerWidth, viewport.width * baseScale);
      const displayHeight = displayWidth * pageAspectRatio;

      const canvas = document.createElement('canvas');
      canvas.className = 'sb-pdf-viewer__canvas';

      // Set canvas size for high-DPI rendering
      canvas.width = renderViewport.width;
      canvas.height = renderViewport.height;

      // Style the canvas for proper display — explicit px, not height:auto
      canvas.style.width = `${displayWidth}px`;
      canvas.style.height = `${displayHeight}px`;
      canvas.style.maxWidth = '100%';
      canvas.style.display = 'block';
      canvas.style.marginLeft = 'auto';
      canvas.style.marginRight = 'auto';

      // For large screens with high DPI, apply additional sharpening
      if (isLargeScreen && isHighDPI) {
        canvas.style.imageRendering = 'crisp-edges';
        canvas.style.imageRendering = '-webkit-crisp-edges';
      }

      return { canvas, renderViewport };
    }

    /**
     * Show the close button in the PDF viewer modal
     */
    showCloseButton() {
      const closeButton = document.querySelector('.sb-pdf-viewer__close');
      if (closeButton) {
        closeButton.style.display = 'flex';
      }
    }

    /**
     * Clear search input and hide results
     */
    clearSearchState() {
      this.hideResults();
    }

    /**
     * Add search to history
     * @param {Object} certificate - Certificate data object
     */
    addToSearchHistory(certificate) {
      let searchHistory = this.getSearchHistory();
      const searchEntry = this.createSearchHistoryEntry(certificate);

      searchHistory = this.removeDuplicateHistoryEntries(searchHistory, certificate.pdfUrl);
      searchHistory = this.addAndLimitHistory(searchHistory, searchEntry);

      this.saveSearchHistory(searchHistory);
      this.refreshSearchHistory();
    }

    /**
     * Get search history from localStorage
     * @returns {Array} Search history array
     */
    getSearchHistory() {
      return JSON.parse(localStorage.getItem('td_search_history') || '[]');
    }

    /**
     * Create search history entry
     * @param {Object} certificate - Certificate data object
     * @returns {Object} Search history entry
     */
    createSearchHistoryEntry(certificate) {
      return {
        date: new Date().toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }),
        productName: certificate.title,
        testType: certificate.analysisType,
        handle: certificate.handle,
        image: this.productService.getProductByHandle(certificate.handle)?.featured_image || '',
        pdfUrl: certificate.pdfUrl,
        timestamp: Date.now(),
      };
    }

    /**
     * Remove duplicate entries for the same certificate
     * @param {Array} searchHistory - Current search history
     * @param {string} pdfUrl - PDF URL to remove duplicates for
     * @returns {Array} Filtered search history
     */
    removeDuplicateHistoryEntries(searchHistory, pdfUrl) {
      return searchHistory.filter((item) => item.pdfUrl !== pdfUrl);
    }

    /**
     * Add new entry and limit history size
     * @param {Array} searchHistory - Current search history
     * @param {Object} searchEntry - New search entry
     * @returns {Array} Updated search history
     */
    addAndLimitHistory(searchHistory, searchEntry) {
      searchHistory.unshift(searchEntry);
      return searchHistory.slice(0, 10);
    }

    /**
     * Save search history to localStorage
     * @param {Array} searchHistory - Search history to save
     */
    saveSearchHistory(searchHistory) {
      localStorage.setItem('td_search_history', JSON.stringify(searchHistory));
    }

    /**
     * Load and display search history
     */
    loadSearchHistory() {
      this.refreshSearchHistory();
    }

    /**
     * Refresh and display the entire search history
     */
    refreshSearchHistory() {
      if (!this.searchHistoryList) return;

      const searchHistory = this.getSearchHistory();
      const searchHistorySection = document.querySelector('.sb-third-party-testing__search-history');

      if (searchHistory.length === 0) {
        this.hideSearchHistorySection(searchHistorySection);
        return;
      }

      this.showSearchHistorySection(searchHistorySection);
      this.renderSearchHistoryItems(searchHistory);
    }

    /**
     * Display search history in the sidebar
     * @deprecated Use refreshSearchHistory() instead
     */
    displaySearchHistory() {
      this.refreshSearchHistory();
    }

    /**
     * Hide search history section
     * @param {HTMLElement} section - Search history section element
     */
    hideSearchHistorySection(section) {
      if (section) {
        section.style.display = 'none';
      }
    }

    /**
     * Show search history section
     * @param {HTMLElement} section - Search history section element
     */
    showSearchHistorySection(section) {
      if (section) {
        section.style.display = 'flex';
      }
    }

    /**
     * Render search history items
     * @param {Array} searchHistory - Search history array
     */
    renderSearchHistoryItems(searchHistory) {
      const template = this.getTemplate('search-history-item-template');
      if (!template) return;

      this.searchHistoryList.innerHTML = '';

      searchHistory.forEach((item) => {
        const clone = template.content.cloneNode(true);
        this.populateSearchHistoryItem(clone, item);
        this.searchHistoryList.appendChild(clone);
      });
    }

    /**
     * Populate search history item data
     * @param {DocumentFragment} clone - Cloned template
     * @param {Object} item - History item data
     */
    populateSearchHistoryItem(clone, item) {
      clone.querySelectorAll('[data-date]').forEach((el) => (el.textContent = item.date));
      clone.querySelectorAll('[data-product-name]').forEach((el) => (el.textContent = item.productName));
      clone.querySelectorAll('[data-test-type]').forEach((el) => (el.textContent = item.testType));

      const imgMount = clone.querySelector('[data-history-image]');
      if (imgMount) {
        let imageSrc = item.image || '';
        if (!imageSrc && item.handle) {
          const productData = this.productService.getProductByHandle(item.handle);
          imageSrc = productData?.featured_image || '';
        }

        if (imageSrc) {
          const img = document.createElement('img');
          img.className = 'sb-third-party-testing__search-history-thumb-img sb-only-desktop';
          img.alt = item.productName || 'Product image';
          img.loading = 'lazy';
          img.src = imageSrc;
          imgMount.replaceWith(img);
        } else {
          // Keep mount as a subtle placeholder block
          imgMount.classList.add('sb-third-party-testing__search-history-thumb-img');
          imgMount.style.backgroundColor = '#f0f2f5';
        }
      }

      const linkEl = clone.querySelector('[data-pdf-link]');
      linkEl.href = 'javascript:void(0);'; // Prevent default navigation
      linkEl.removeAttribute('target');

      // Add click event to open in modal instead
      linkEl.addEventListener('click', (e) => {
        e.preventDefault();
        this.openCertificateInModal(item.pdfUrl);
      });
    }

    /**
     * Display recent product in the main section
     * @param {Object} certificate - Certificate data object
     */
    displayRecentProduct(certificate) {
      if (!this.recentProductContainer || !this.recentProductContent) return;

      const template = this.getTemplate('recent-product-template');
      if (!template) return;

      if (this.recentTitle) {
        this.recentTitle.classList.remove('sb-third-party-testing__recent-title--hidden');
      }

      const clone = template.content.cloneNode(true);
      const productData = this.productService.getProductByHandle(certificate.handle);
      this.setRecentProductImage(clone, certificate, productData);
      this.setRecentProductTitle(clone, certificate, productData);
      this.setRecentProductDescription(clone, certificate, productData);
      this.setRecentProductLink(clone, certificate);
      this.displayRecentProductContent(clone);
    }

    /**
     * Set recent product image
     * @param {DocumentFragment} clone - Cloned template
     * @param {Object} certificate - Certificate data
     * @param {Object} productData - Product data
     */
    setRecentProductImage(clone, certificate, productData) {
      const imageEl = clone.querySelector('[data-image]');
      if (productData?.featured_image) {
        const img = document.createElement('img');
        img.src = productData.featured_image;
        img.alt = certificate.title;
        img.className = 'sb-third-party-testing__recent-image';
        img.loading = 'lazy';
        imageEl.replaceWith(img);
      } else {
        imageEl.style.backgroundColor = '#f8f9fb';
      }
    }

    /**
     * Set recent product title
     * @param {DocumentFragment} clone - Cloned template
     * @param {Object} certificate - Certificate data
     * @param {Object} productData - Product data
     */
    setRecentProductTitle(clone, certificate, productData) {
      const displayTitle = productData?.title || certificate.title;
      clone.querySelector('[data-title]').textContent = displayTitle;
    }

    /**
     * Set recent product description
     * @param {DocumentFragment} clone - Cloned template
     * @param {Object} certificate - Certificate data
     * @param {Object} productData - Product data
     */
    setRecentProductDescription(clone, certificate, productData) {
      const description = this.getProductDescription(certificate, productData);
      const cleanLimitedText = this.cleanAndLimitText(description, 18);
      clone.querySelector('[data-description]').textContent = cleanLimitedText;
    }

    /**
     * Get product description from various sources
     * @param {Object} certificate - Certificate data
     * @param {Object} productData - Product data
     * @returns {string} Description text
     */
    getProductDescription(certificate, productData) {
      if (productData?.description) {
        if (productData.metafields?.plp_product_short_description) {
          return productData.metafields.plp_product_short_description;
        }
        return productData.description;
      }
      return `Lot Number: ${certificate.lotNumber} | Test Type: ${certificate.analysisType} | Date: ${certificate.testDate}`;
    }

    /**
     * Clean HTML and limit text to specified word count
     * @param {string} text - Text to clean and limit
     * @param {number} wordLimit - Maximum number of words
     * @returns {string} Clean, limited text
     */
    cleanAndLimitText(text, wordLimit) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = text;
      const cleanText = tempDiv.textContent || tempDiv.innerText || '';
      return cleanText.split(' ').slice(0, wordLimit).join(' ');
    }

    /**
     * Set recent product link
     * @param {DocumentFragment} clone - Cloned template
     * @param {Object} certificate - Certificate data
     */
    setRecentProductLink(clone, certificate) {
      const productUrl = `/products/${certificate.handle}`;

      const contentLinkEl = clone.querySelector('[data-content-link]');
      if (contentLinkEl) {
        contentLinkEl.href = productUrl;
      }
    }

    /**
     * Display recent product content
     * @param {DocumentFragment} clone - Cloned template content
     */
    displayRecentProductContent(clone) {
      this.recentProductContent.innerHTML = '';
      this.recentProductContent.appendChild(clone);
      this.recentProductContainer.classList.add('sb-third-party-testing__recent-product--visible');
    }

    /**
     * Load and display the most recent product
     */
    loadRecentProduct() {
      const recentProduct = localStorage.getItem('td_recent_product');
      if (recentProduct) {
        try {
          const productData = JSON.parse(recentProduct);
          this.displayRecentProduct(productData);
        } catch (error) {
          console.error('Error loading recent product:', error);
        }
      }
    }

    /**
     * Show search results dropdown
     */
    showResults() {
      if (this.searchResults) {
        this.searchResults.classList.add('sb-third-party-testing__search-results--visible');
      }
    }

    /**
     * Hide search results dropdown
     */
    hideResults() {
      if (this.searchResults) {
        this.searchResults.classList.remove('sb-third-party-testing__search-results--visible');
      }
    }

    /**
     * Set result details (test type and date)
     * @param {DocumentFragment} clone - Cloned template
     * @param {Object} cert - Certificate data
     */
    setResultDetails(clone, cert) {
      const typeEl = clone.querySelector('[data-analysis-display-child]');
      const dateEl = clone.querySelector('[data-test-date-child]');

      // Set test type (normalized label, so spelling variants display the same)
      if (typeEl) {
        typeEl.textContent = getAnalysisTypeLabel(cert);
      }

      // Set date (parsed manually, so it displays correctly in every browser)
      if (dateEl && cert.date) {
        dateEl.textContent = getDisplayDate(cert);
      }
    }
  }

  // Register the custom element
  customElements.define('sb-product-search', TdProductSearch);
}